import React, { Component } from 'react'
import './CheckRequest.css'
import '../MainPanel.css'
import SideNav from '../sidenav/Sidenav'
import EditDetails from '../editreturned/Draft'

import ApprovedStamp from './approvedstamp.svg'
import ReturnedStamp from './returnedstamp.svg'
import RejectedStamp from './rejectedstamp.svg'
import ReviewedStamp from './reviewedstamp.svg'
import OnHoldStamp from './onholdstamp.svg'

import ForApprovalImg from './forapproval.PNG'
import ForTransmittalImg from './fortransmittal.png'
import ForReviewImg from './forreview.png'
import ForEndorsementImg from './forEndorsement.png'

import PhaseTwoInactive from './phasetwoinactive.png'
import PhaseOneDone from './phase1done.png'

import InProcessImg from './inprocess.png'
import CheckPreparationImg from './checkpreparation.png'
import CheckPreparedImg from './checkprepared.png'
import CheckAvailableImg from './checkavailable.png'
import CheckReleasedImg from './checkreleased.png'
import { getData } from '../draft/actions'
import Modals from './Modals'
import OrModal from '../orModal/orModal'
import { CrfContext } from '../../CrfContext'
import axios from 'axios'
import Backdrop from '../../components/controlledBackdrop/backdrop'
// import { Transition, animated } from 'react-spring/renderprops';

export class CheckRequest extends Component {
  state = {
    modalState: false,
    accountingManager: [],
    departmentApprover: '',
    accountingApprover: '',
    comptrollerApprover: '',
    cooApprover: '',
    file: '',
    dateNeeded: '',
    vendor: '',
    particulars: '',
    requestingDepartment: '',
    poNumber: '',
    project: '',
    subProject: '',
    dueDate: '',
    supportingDocuments: '',
    newProjectClass: [],
    projectClass: [{}],
    oldProjectClass: [],
    checkDate: null,
    dateReleased: null,
    checkAvailableDate: null,
    checkNo: null,
    crfNo: '',
    requestType: '',
    status: '',
    requestor: '',
    accountType: [],
    accountName: [],
    totalGrossPrice: 0,
    totalUnitPrice: 0,
    quantity: [],
    rejectionMessage: [],

    _id: '',
    crfLink: '',

    userRole: '',
    showReturnModal: false,
    showReturnModalContent: false,
    reason: '',

    returnRequest: false,
    approveRequest: false,
    compApproveRequest: false,
    cooApproveRequest: false,
    rejectRequest: false,
    transmitRequest: false,
    reviewRequest: false,
    onHoldRequest: false,
    endorseRequest: false,

    editCrfDetails: false,
    crfReturned: false,

    temporaryVendor: '',

    vendorLists: [],
    departmentLists: [],
    projectLists: [],

    accountTypes: [],

    cocExpenses: [],
    advances: [],
    ppeAccounts: [],
    adminExpenses: [],
    advancesProjectClass: [],
    itemNoLists: [],

    wTaxRates: [],
    vatTypeSelector: '',

    expectedCompletion: '',

    showEdit1: false,
    pageSelected: 1 * 5 - 1,

    increment: 0,
    loading: false,
    crfAdded: false,
    grandTotalGrossPrice: 0.0,
    grandTotalNetPrice: 0.0,
    orObj: null,
    addToQueue: true,
    isLoading: true,
    cocExpensesState: false,
    advancesState: false,
    ppeAccountsState: false,
    adminExpensesState: false,
    projectClassesState: false
  }

  async orRequest(crfNo) {
    const { data } = await getData(`/api/orUpload/${crfNo}`)
    if (data) {
      this.setState({ orObj: data })
    } else {
      this.setState({ orObj: null })
    }
  }
  orModal = () => {
    this.setState({
      modalState: !this.state.modalState
    })
  }
  async componentDidMount() {
    // =======================================================================================================
    // START
    // ==================================================================================================================================
    // GET COC EXPENSES
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/COC Expenses`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // console.log(response.data.data[0].accountName)
        let cocExpenses = []
        for (let i = 0; i < response.data.data.length; i++) {
          cocExpenses.push(
            response.data.data[i].accountCode +
            ' ' +
            response.data.data[i].accountName
          )
        }

        this.setState({
          cocExpenses: cocExpenses
        })
        // console.log(this.state.cocExpenses)
      })
      .catch(error => { })

    // ======================================================================================
    // GET ADVANCES LIST
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Advances`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // console.log(response)
        let advances = []
        for (let i = 0; i < response.data.data.length; i++) {
          advances.push(
            response.data.data[i].accountCode +
            ' ' +
            response.data.data[i].accountName
          )
        }
        this.setState({
          advances: advances
        })
        // console.log(this.state.advances)
      })
      .catch(error => {
        // console.log(error.response)
      })

    // ===============================================================================
    // GET PPE ACCOUNT LIST
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/PPE Accounts`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        let ppeAccount = []
        for (let i = 0; i < response.data.data.length; i++) {
          ppeAccount.push(
            response.data.data[i].accountCode +
            ' ' +
            response.data.data[i].accountName
          )
        }
        this.setState({
          ppeAccounts: ppeAccount
        })
      })
      .catch(error => {
        // console.log(error.response)
      })
    // ========================================================================================
    //  GET ADMIN EXPENSES

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Admin Expenses`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // console.log(response)
        let adminExpenses = []
        for (let i = 0; i < response.data.data.length; i++) {
          adminExpenses.push(
            response.data.data[i].accountCode +
            ' ' +
            response.data.data[i].accountName
          )
        }
        this.setState({
          adminExpenses: adminExpenses
        })
      })
      .catch(error => {
        // console.log(error.response)
      })
    //=========================================================================================

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/projectClasses`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        this.setState({
          advancesProjectClass: response.data.data
        })
        console.log(this.state.advancesProjectClass)
      })
      .catch(error => {
        console.log(error.response)
      })
    // END
    // ===================================================================
    // GET VENDOR LIST
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/vendors`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // document.getElementById('main').style.display = 'block'
        console.log(response)
        this.setState({
          vendorLists: response.data.data
        })
        console.log(this.state.vendorLists)
      })
      .catch(error => {
        console.log(error.response)
      })
    //================================================================================

    // GET PROJECT LIST

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/projects`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        this.setState({
          projectLists: response.data.data
        })
      })
      .catch(error => {
        console.log(error.response)
      })

    // ============================================================================
    // GET COC EXPENSES
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/COC Expenses`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // console.log(response.data.data[0].accountName)
        let cocExpenses = []
        for (let i = 0; i < response.data.data.length; i++) {
          cocExpenses.push(
            response.data.data[i].accountCode +
            ' ' +
            response.data.data[i].accountName
          )
        }

        this.setState({
          cocExpenses: cocExpenses
        })
        // console.log(this.state.cocExpenses)
      })
      .catch(error => {
        console.log(error.response)
      })

    // ======================================================================================
    // GET ADVANCES LIST
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Advances`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // console.log(response)
        let advances = []
        for (let i = 0; i < response.data.data.length; i++) {
          advances.push(
            response.data.data[i].accountCode +
            ' ' +
            response.data.data[i].accountName
          )
        }
        this.setState({
          advances: advances
        })
        // console.log(this.state.advances)
      })
      .catch(error => {
        // console.log(error.response)
      })

    // ===============================================================================
    // GET PPE ACCOUNT LIST
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/PPE Accounts`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        let ppeAccount = []
        for (let i = 0; i < response.data.data.length; i++) {
          ppeAccount.push(
            response.data.data[i].accountCode +
            ' ' +
            response.data.data[i].accountName
          )
        }
        this.setState({
          ppeAccounts: ppeAccount
        })
      })
      .catch(error => {
        // console.log(error.response)
      })
    // ========================================================================================
    //  GET ADMIN EXPENSES

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Admin Expenses`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // console.log(response)
        let adminExpenses = []
        for (let i = 0; i < response.data.data.length; i++) {
          adminExpenses.push(
            response.data.data[i].accountCode +
            ' ' +
            response.data.data[i].accountName
          )
        }
        this.setState({
          adminExpenses: adminExpenses
        })
      })
      .catch(error => {
        // console.log(error.response)
      })
    //=========================================================================================

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/projectClasses`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        this.setState({
          advancesProjectClass: response.data.data
        })
        console.log(this.state.advancesProjectClass)
      })
      .catch(error => {
        console.log(error.response)
      })

    // ===================================================================================================================================
    // CRF DETAILS

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/${this.props.match.params.id}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response.data.data)
        this.orRequest(response.data.data.crfNo)
        if (response.data.data.accountingManager) {
          this.setState({
            accountingManager: response.data.data.accountingManager
          })
        }
        let totalNet = 0
        let totalGp = 0

        for (let i = 0; i < response.data.data.projectClasses.length; i++) {
          totalGp =
            totalGp +
            response.data.data.projectClasses[i].apv.subTotalGrossPrice
          totalNet =
            totalNet + response.data.data.projectClasses[i].apv.subTotalNetPrice
        }
        //totalGrossPrice and totalNetPrice
        this.setState({
          grandTotalGrossPrice: totalGp
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, '$&,'),
          grandTotalNetPrice: totalNet
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, '$&,')
        })

        const data = response.data.data
        if (data.expectedCompletionDate) {
          this.setState({
            expectedCompletion: data.expectedCompletionDate
          })
        }
        if (data.departmentApprover) {
          this.setState({
            departmentApprover:
              data.departmentApprover.firstName +
              ' ' +
              data.departmentApprover.lastName
          })
        }

        if (data.accountingApprover) {
          this.setState({
            accountingApprover:
              data.accountingApprover.firstName +
              ' ' +
              data.accountingApprover.lastName
          })
        }

        if (data.comptrollerApprover) {
          this.setState({
            comptrollerApprover:
              data.comptrollerApprover.firstName +
              ' ' +
              data.comptrollerApprover.lastName
          })
        }

        if (data.cooApprover) {
          this.setState({
            cooApprover:
              data.cooApprover.firstName +
              ' ' +
              data.cooApprover.lastName
          })
        }

        let newProjectClass = []

        for (let i = 0; i < data.projectClasses.length; i++) {
          console.log(data)
          newProjectClass.push({
            glCategory: data.projectClasses[i].glAccount.accountType,
            glAccount: data.projectClasses[i].glAccount.accountCode,
            projectClass: data.projectClasses[i].glAccount.centerName,
            description1: data.projectClasses[i].description1,
            description2: data.projectClasses[i].description2,
            quantity: data.projectClasses[i].quantity,
            itemCode: data.projectClasses[i].itemCode,
            grossPricePerItem: data.projectClasses[i].grossPricePerItem,
            unitPrice: data.projectClasses[i].apv.unitPrice,
            vatType: data.projectClasses[i].vatType,
            vatTypeValue:
              data.projectClasses[i].vatType === 'Goods IVAT-G' ||
                data.projectClasses[i].vatType === 'Services IVAT-S'
                ? 1 + 0.12
                : 1,
            wTax: data.projectClasses[i].apv.wTax,
            wTaxType: 'X1',
            wTaxTypeValue: 0,
            netPricePerItem: data.projectClasses[i].apv.netPricePerItem
          })
        }

        console.log(data.projectClasses)

        //this is for add to queue module
        axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_KEY}/api/inQueue/${data.crfNo}?status=onGoing`,
          headers: {
            'Api-Key':
              '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
            Authorization: `Bearer ${localStorage.token}`
          }
        })
          .then(response => {
            console.log(response.data.data)
            if (response.data.data) {
              this.setState({ addToQueue: false })
            }
          })
          .catch(error => {
            console.log(error.response)
          })
        this.setState((state, props) => ({
          crfNo: data.crfNo,
          poNumber: data.poNumber,
          requestType: data.requestType,
          requestType: data.requestType,
          requestor: data.requestor.firstName + ' ' + data.requestor.lastName,
          requestingDepartment: data.department.centerName,
          status: data.status,
          vendor: data.vendor.bpName,
          particulars: data.particulars,
          project: data.project.projectName,
          subProject: data.subProject,
          projectClass: data.projectClasses,
          dueDate: data.dueDate,
          creationDate: data.creationDate,
          _id: data._idDate,
          rejectionMessage: data.rejectionMessage,
          newProjectClass: newProjectClass,
          checkDate: data.checkDate ? data.checkDate : null,
          checkAvailableDate: data.checkAvailableDate
            ? data.checkAvailableDate
            : null,
          checkNo: data.checkNo ? data.checkNo : null,
          dateReleased: data.dateReleased ? data.dateReleased.split('-') : null

          // newProjectClass: newProjectClasses,
        }))

        if (data.departmentApprover) {
          this.setState({
            departmentApprover:
              data.departmentApprover.firstName +
              ' ' +
              data.departmentApprover.lastName
          })
        }

        if (data.accountingApprover) {
          this.setState({
            accountingApprover:
              data.accountingApprover.firstName +
              ' ' +
              data.accountingApprover.lastName
          })
        }

        if (data.comptrollerApprover) {
          this.setState({
            comptrollerApprover:
              data.comptrollerApprover.firstName +
              ' ' +
              data.comptrollerApprover.lastName
          })
        }

        if (data.cooApprover) {
          this.setState({
            cooApprover:
              data.cooApprover.firstName +
              ' ' +
              data.cooApprover.lastName
          })
        }

        // =============================================================================================================
        // VENDOR BP CODE WILL GET THE WTAX

        axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${data.vendor.bpCode}`,
          headers: {
            'Api-Key':
              '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
            Authorization: `Bearer ${localStorage.token}`
          }
        })
          .then(response => {
            console.log(response)
            const none = {
              wTaxCode: 'X1',
              wTaxName: '',
              wTaxDisplayName: 'None ',
              rate: '0'
            }
            let newArray = response.data.data
            newArray.push(none)
            this.setState({
              wTaxRates: newArray
            })
            console.log(this.state.wTaxRates)
          })
          .catch(error => {
            console.log(error.response)
          })

        // ================================================================================================================
        axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_KEY}/api/projects/${data.project.projectName}`,
          headers: {
            'Api-Key':
              '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
            Authorization: `Bearer ${localStorage.token}`
          }
        })
          .then(response => {
            console.log(response)
            this.setState({
              projectCode: response.data.data.projectCode
            })
            console.log(this.state.projectCode)

            // GET THE GLNAME
            axios({
              method: 'GET',
              url: `${process.env.REACT_APP_API_KEY}/api/glAccountTypes/${response.data.data.projectCode}`,
              headers: {
                'Api-Key':
                  '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                Authorization: `Bearer ${localStorage.token}`
              }
            })
              .then(response => {
                console.log(response)
                this.setState({
                  accountTypes: response.data.data
                })
                console.log(this.state.accountTypes)
              })
              .catch(error => {
                console.log(error.response)
                this.setState({
                  accountTypes: []
                })
              })
          })
          .catch(error => {
            console.log(error.response)
          })

        // ============================================================================================================
        // GET THE WTAXTYPE FOR  INITIAL VALUE OF RESUBMIT
        console.log(data.vendor)
        axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_KEY}/api/vendors/${data.vendor}`,
          headers: {
            'Api-Key':
              '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
            Authorization: `Bearer ${localStorage.token}`
          }
        })
          .then(response => {
            console.log(response)
            this.setState({
              vatTypeSelector: response.data.data.vatType
            })
          })
          .catch(error => {
            console.log(error.response)
          })

        // GET THE wTaxRates

        // =========================================================================================================================================

        // this.setState((state, props) => ({
        //       crfNo: data.crfNo,
        //       poNumber: data.poNumber,
        //       requestType: data.requestType,
        //       requestType: data.requestType,
        //       requestor: data.requestor.firstName + " " +
        //       data.requestor.lastName,
        //       requestingDepartment: data.department.centerName,
        //       status: data.status,
        //       vendor: data.vendor.bpName,
        //       particulars: data.particulars,
        //       project: data.project.projectName,
        //       subProject: data.subProject,
        //       projectClass: data.projectClasses,
        //       dueDate: data.dueDate,
        //       creationDate: data.creationDate,
        //       _id: data._idDate,
        //       rejectionMessage: data.rejectionMessage,
        // }))

        let accountType = []
        let accountName = []
        let quantity = []
        let subtotalGrossPrice = []
        let subtotalUnitPrice = []
        for (let i = 0; i < this.state.projectClass.length; i++) {
          accountType.push(this.state.projectClass[i].glAccount.accountType)
          accountName.push(this.state.projectClass[i].glAccount.accountName)
          quantity.push(this.state.projectClass[i].quantity)
          subtotalGrossPrice.push(
            this.state.projectClass[i].grossPrice *
            this.state.projectClass[i].quantity
          )
          subtotalUnitPrice.push(this.state.projectClass[i].unitPrice)
        }

        let totalGrossPrice = 0
        for (let subt = 0; subt < this.state.projectClass.length; subt++) {
          totalGrossPrice = totalGrossPrice + subtotalGrossPrice[subt]
        }

        let totalUnitPrice = 0
        for (let subt = 0; subt < this.state.projectClass.length; subt++) {
          totalUnitPrice = totalUnitPrice + subtotalUnitPrice[subt]
        }
        console.log(totalGrossPrice)

        this.setState({
          accountType: accountType,
          accountName: accountName,
          totalGrossPrice: totalGrossPrice,
          quantity: quantity,
          totalUnitPrice: totalUnitPrice
        })
        this.setState({ isLoading: false })
      })
      .catch(error => {
        console.log(error.response)
      })

    console.log(this.state.newProjectClass)
    console.log(this.state)

    // for (let i = 0; i < this.state.projectClass.length; i++) {
    //   console.log(i)

    //   if(document.getElementsByClassName('glNameClassEdit')[i] !== undefined){
    //       document.getElementsByClassName('glNameClassEdit')[i].value =
    //       this.state.projectClass[i].glAccount.accountCode + " " +
    //       this.state.projectClass[i].glAccount.accountName
    //   }
    // }

    console.log(this.state.newProjectClass)

    // =========================================================================================
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/itemNo`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        // document.getElementById('main').style.display = 'block'
        console.log(response)
        this.setState({
          itemNoLists: response.data.data
        })
      })
      .catch(error => {
        console.log(error.response)
      })
  }

  // ===================================== MODAL HANDLER =================

  handleShowRejectModal = () => {
    this.setState({
      rejectRequest: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleShowReturnModal = () => {
    this.setState({
      reviewRequest: false,
      returnRequest: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleShowApproveModal = () => {
    this.setState({
      approveRequest: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleShowCompApproveModal = () => {
    this.setState({
      compApproveRequest: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleShowCOOApproveModal = () => {
    this.setState({
      cooApproveRequest: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleShowForTransmittalModal = () => {
    this.setState({
      transmitRequest: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleShowReviewModal = () => {
    console.log('test')
    this.setState({
      reviewRequest: true,
      returnRequest: false
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleShowEndorseModal = () => {
    console.log('test')
    this.setState({
      onHoldRequest: false,
      endorseRequest: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  handleShowOnHoldModal = () => {
    console.log('test')
    this.setState({
      endorseRequest: false,
      onHoldRequest: true
    })
    document.getElementById('modalBody').style.display = 'block'
  }

  closeReturnModal = e => {
    e.preventDefault()
    this.setState({
      approveRequest: false
    })
    document.getElementById('modalBody').style.display = 'none'
  }

  // ======================================= END OF MODAL HANDLER ==============
  // ============================================ UPDATE STATUS HANDLER ====================

  handleRejectRequest = e => {
    e.preventDefault()

    if (document.getElementById('returnMessage').value !== '') {
      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/reject/${this.props.match.params.id}`,
        data: {
          reason: this.state.reason
        },
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          if (
            response.data.data === 'Check request form successfully rejected'
          ) {
            window.location.reload()
          }
          // this.props.history.push("/CheckRequest/"+this.props.match.params.id)
        })
        .catch(error => {
          console.log(error.response)
        })
    } else {
      e.preventDefault()
      document.getElementById('returnValidation').innerText =
        'Please input a message'
    }
  }

  handleReturnRequest = e => {
    e.preventDefault()
    console.log(this.props.match.params.id)
    if (document.getElementById('returnMessage').value !== '') {
      axios({
        method: 'PUT',
        url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/return/${this.props.match.params.id}`,
        data: {
          reason: this.state.reason
        },
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          // console.log(response.data.data)
          // window.location.reload()
          // this.props.history.push("/CheckRequest/"+this.props.match.params.id)
          if (
            response.data.data === 'Check request form successfully returned'
          ) {
            window.location.reload()
          }
        })
        .catch(error => {
          console.log(error.response)
        })
    } else {
      e.preventDefault()
      document.getElementById('returnValidation').innerText =
        'Please input a message'
    }
  }

  handleApproveCrf = () => {
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/forCompApproval/${this.props.match.params.id}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        const { data } = response.data
        if (data.nModified === 1) {
          window.history.back()
        }
      })
      .catch(error => {
        alert('oops something went wrong')
        console.log(error.response)
      })
  }

  handleCompApproveCrf = () => {
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/forCooApproval/${this.props.match.params.id}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        const { data } = response.data
        if (data.nModified === 1) {
          window.history.back()
        }
      })
      .catch(error => {
        alert('oops something went wrong')
        console.log(error.response)
      })
  }

  handleCooApproveCrf = () => {
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/forTransmittal/${this.props.match.params.id}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        const { data } = response.data
        if (data.nModified === 1) {
          window.location.reload()
        }
      })
      .catch(error => {
        alert('oops something went wrong')
        console.log(error.response)
      })
  }

  handleTransmitted = e => {
    e.preventDefault()
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/forReview/${this.props.match.params.id}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        if (response.data.data.nModified === 1) {
          window.location.reload()
        }
      })
      .catch(error => {
        console.log(error.response)
      })
  }

  handleReviewed = e => {
    e.preventDefault()
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/forEndorsement/${this.props.match.params.id}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        if (response.data.data.nModified === 1) {
          window.location.reload()
        }
      })
      .catch(error => {
        console.log(error.response)
      })
  }

  handleInprocess = e => {
    e.preventDefault()
    console.log('test')
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/inProcess/${this.props.match.params.id}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        window.location.reload()
      })
      .catch(error => {
        console.log(error.response)
      })
  }

  handleOnHold = e => {
    // e.preventDefault()
    console.log('test')
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/onHold/${this.props.match.params.id}`,
      data: {
        reason: this.state.reason
      },
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        if (response.data.data.nModified === 1) {
          window.location.reload()
        }
      })
      .catch(error => {
        console.log(error.response)
        document.getElementById('returnValidation').innerText =
          'Please input a message'
      })
  }

  // ============================================= END OF UPDATE STATUS HANDLER =======================
  handleDownloadPdf = () => {
    axios(
      `${process.env.REACT_APP_API_KEY}/api/uploads/${this.props.match.params.id}`,
      {
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
        //Force to receive data in a Blob Format
      }
    )
      .then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], {
          type: 'application/pdf'
        })
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file)
        //Open the URL on new Window
        window.open(fileURL)
      })
      .catch(error => {
        console.log(error)
        alert('File not Found')
      })
  }

  handleOrUpload = () => {
    axios(
      `${process.env.REACT_APP_API_KEY}/api/orUpload/display/${this.state.orObj.crfNo}`,
      {
        method: 'GET',
        responseType: 'blob',
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
        //Force to receive data in a Blob Format
      }
    )
      .then(response => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], {
          type: 'application/pdf'
        })
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file)
        //Open the URL on new Window
        window.open(fileURL)
      })
      .catch(error => {
        console.log(error)
        alert('File not Found')
      })
  }

  handleChangeState = e => {
    e.preventDefault()
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleCancelResubmit = () => {
    window.location.reload()
  }

  // THIS WILL GIVE THE INITIAL VALUE TO RESUBMIT FORM
  // handleShowEdit1 = () => {
  //   console.log('test')
  //   document.getElementById("approverBtnFieldResubmit").style.display = "inline"
  //   document.getElementById("approverBtnFieldResubmit2").style.display = "inline"
  //   document.getElementById('projectClassResubmitForm').style.display = "block"
  //   let projectClassContainer = document.getElementsByClassName('projectClassListContainer')
  //   console.log(this.state.projectClass)
  //   console.log(document.getElementsByName('glCategory')[0])
  //   for (let i = 0; i < this.state.projectClass.length; i++) {
  //     document.getElementsByClassName('glCategoryInitialValue')[i].innerText =
  //     this.state.projectClass[i].glAccount.accountType

  //     document.getElementsByClassName('glNameClass')[i].value =
  //     this.state.projectClass[i].glAccount.accountCode + " " +
  //     this.state.projectClass[i].glAccount.accountName

  //     if(this.state.projectClass[i].glAccount.accountType !== "Advances"){
  //       document.getElementsByName('projectClass')[i].style.display = 'none'
  //       document.getElementsByName('projectClassLabel')[i].style.display = 'none'
  //       document.getElementsByClassName('glNameClass')[i].setAttribute('list', 'advances')
  //     }

  //     if(this.state.projectClass[i].glAccount.accountType === "Advances"){
  //         document.getElementsByName('projectClass')[i].setAttribute('list', 'projectClass')
  //         document.getElementsByName('projectClass')[i].value = this.state.projectClass[i].glAccount.centerName
  //       }

  //     if(this.state.projectClass[i].glAccount.accountType === "COC Expenses"){
  //       document.getElementsByClassName('glNameClass')[i].setAttribute('list', 'ppeAccounts')
  //       console.log(document.getElementsByClassName('glNameClass')[i])
  //     }

  //     if(this.state.projectClass[i].glAccount.accountType === "PPE Accounts"){
  //       document.getElementsByClassName('glNameClass')[i].setAttribute('list', 'ppeAccounts')
  //       console.log(document.getElementsByClassName('glNameClass')[i])
  //     }

  //     if(this.state.projectClass[i].glAccount.accountType === "Admin Expenses"){
  //       document.getElementsByClassName('glNameClass')[i].setAttribute('list', 'adminExpenses')
  //       console.log(document.getElementsByClassName('glNameClass')[i])
  //     }

  //     document.getElementsByName('description1')[i].value = this.state.projectClass[i].description1
  //     document.getElementsByName('description2')[i].value = this.state.projectClass[i].description2
  //     document.getElementsByName('grossPricePerItem')[i].value = this.state.projectClass[i].grossPricePerItem

  //     document.getElementsByName('vatTypeInitialValue')[i].innerText = this.state.projectClass[i].vatType
  //     document.getElementsByName('vatTypeInitialValue')[i].value = this.state.projectClass[i].vatType

  //     document.getElementsByName('wTaxTypeInitialValue')[i].innerText = this.state.projectClass[i].wTaxType
  //     document.getElementsByName('wTaxTypeInitialValue')[i].value = this.state.projectClass[i].wTaxCode

  //   }

  // }

  handleChangeRequestField = e => {
    console.log(e.target.value)

    if (e.target.name === 'vendor') {
      if (!this.state.vendorLists.includes(e.target.value)) {
        e.target.nextElementSibling.style.display = 'inline'
        e.target.nextElementSibling.children[1].innerText = 'Invalid Input!'
      }
      if (e.target.value === '') {
        e.target.nextElementSibling.style.display = 'inline'
        e.target.nextElementSibling.children[1].innerText =
          'Vendor input is empty!'
      } else {
        if (this.state.vendorLists.includes(e.target.value)) {
          e.target.nextElementSibling.style.display = 'none'
        }
      }
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/vendors/${e.target.value}`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          this.setState({
            vatTypeSelector: response.data.data.vatType
          })

          // GET wTaxRates

          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response.data.data.bpCode}`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
              let newArray = response.data.data
              // const none = {
              //   wTaxCode: "X1",
              //   wTaxName: "",
              //   wTaxDisplayName: "None X1",
              //   rate: "0",
              // }
              // newArray.push(none)
              this.setState({
                wTaxRates: response.data.data
              })
              console.log(this.state.wTaxRates)
            })
            .catch(error => {
              console.log(error.response)
            })
        })
        .catch(error => {
          console.log(error.response)
        })

      for (
        let i = 0;
        i < document.getElementsByName('vatTypeInitialValue').length;
        i++
      ) {
        document.getElementsByName('vatTypeInitialValue')[i].innerText =
          'Please Choose...'
        document.getElementsByName('vatTypeInitialValue')[i].value = ''
        document
          .getElementsByName('vatTypeInitialValue')
        [i].setAttribute('disabled', '')
        document
          .getElementsByName('vatTypeInitialValue')
        [i].setAttribute('selected', '')
        this.setState(() => (this.state.newProjectClass[i].vatType = ''))
      }
      // THIS WILL RESET THE VALUE OF wTaxType FIELD VALUE
      for (
        let i = 0;
        i < document.getElementsByName('wTaxTypeInitialValue').length;
        i++
      ) {
        document.getElementsByName('wTaxTypeInitialValue')[i].innerText =
          'Please Choose...'
        this.setState(() => (this.state.newProjectClass[i].wTaxType = ''))
      }

      console.log(document.getElementsByName('vatTypeInitialValue'))
    }

    if (e.target.name === 'file' && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split('.')
      let fileExtension = fileName[1]
      // fileExtension !== 'pdf' ? document.getElementById('documentEmptyError')
      // .innerText = "(Please upload a valid file(pdf).)":
      // document.getElementById('documentEmptyError').innerText = ""
      if (fileExtension !== 'pdf') {
        // console.log(document.getElementById('fileUploadedValidation'))
        document.getElementById('fileUploadedValidation').style.display =
          'block'
        document.getElementById(
          'fileUploadedValidation'
        ).children[1].innerText =
          e.target.files[0].name + ' is not a valid file.'

        // e.target.nextElementSibling.style.display ="inline"
        // e.target.nextElementSibling.style.position ="static"
        // e.target.nextElementSibling.children[1].innerText = e.target.files[0].name
      } else {
        document.getElementById('fileUploadedValidation').style.display = 'none'
      }
    }

    let file = null
    if (e.target.name === 'file') {
      console.log(e.target.files[0])
      file = e.target.files[0]
      console.log(file)
      this.setState({
        [e.target.name]: e.target.files[0]
      })
      console.log(this.state.file)
    } else {
      this.setState({
        [e.target.name]: e.target.value
      })
      let project = document.getElementById('projectInput').value

      let glCategoryInputs = document.getElementsByClassName('glCategoryClass')
      let glNameInputs = document.getElementsByClassName('glNameClass')
      let advancesProjectClassInput = document.getElementsByClassName(
        'advancesProjectClassInput'
      )

      // if(e.target.name === 'project'){
      //   for (let i = 0; i < glCategoryInputs.length; i++) {
      //     glCategoryInputs[i].value = ""
      //     glNameInputs[i].value = ""
      //     advancesProjectClassInput[i].value = ""
      //     glNameInputs[i].nextElementSibling.nextElementSibling.style.display = 'none'
      //     this.setState(()=> this.state.projectClass[i].glCategory = "")
      //     this.setState(()=> this.state.projectClass[i].glAccount = "")
      //     this.setState(()=> this.state.projectClass[i].projectClass = "")
    }
    console.log(this.state)

    if (e.target.name === 'particulars') {
      if (e.target.value === '') {
        e.target.nextElementSibling.style.display = 'block'
        e.target.nextElementSibling.children[1].innerText =
          'Particulars Input is Empty'
      } else {
        e.target.nextElementSibling.style.display = 'none'
      }
    }

    if (e.target.name === 'project') {
      // console.log(e.target.value)
      if (!this.state.projectLists.includes(e.target.value)) {
        e.target.nextElementSibling.style.display = 'inline'
        e.target.nextElementSibling.children[1].innerText = 'Invalid Input!'
      }

      if (e.target.value === '') {
        e.target.nextElementSibling.style.display = 'inline'
        e.target.nextElementSibling.children[1].innerText =
          'Project input is empty!'
      } else {
        if (this.state.projectLists.includes(e.target.value)) {
          e.target.nextElementSibling.style.display = 'none'
        }
      }

      console.log(document.getElementsByClassName('glCategoryInitialValue'))

      for (
        let i = 0;
        i < document.getElementsByClassName('glCategoryInitialValue').length;
        i++
      ) {
        document.getElementsByClassName('glCategoryInitialValue')[i].innerText =
          'Please Choose...'
        document.getElementsByClassName('glCategoryInitialValue').value = ''
        this.setState(() => (this.state.newProjectClass[i].glCategory = ''))
        this.setState(() => (this.state.newProjectClass[i].projectClass = ''))
        document.getElementsByName('glAccount')[i].value = ''
        document.getElementsByClassName('projectClassEditDiv')[
          i
        ].style.display = 'none'
        document.getElementsByName('projectClass')[i].value = ''
      }

      this.setState({
        accountTypes: []
      })

      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/projects/${e.target.value}`,
        headers: {
          'Api-Key':
            '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
          Authorization: `Bearer ${localStorage.token}`
        }
      })
        .then(response => {
          console.log(response)
          this.setState({
            projectCode: response.data.data.projectCode
          })
          console.log(this.state.projectCode)

          // GET THE GLNAME
          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/glAccountTypes/${response.data.data.projectCode}`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response)
              this.setState({
                accountTypes: response.data.data
              })
              console.log(this.state.accountTypes)
            })
            .catch(error => {
              console.log(error.response)
              this.setState({
                accountTypes: []
              })
            })
        })
        .catch(error => {
          console.log(error.response)
        })
    }
  }

  handleResubmitReturned = e => {
    e.preventDefault()
    console.log(this.state.projectClass)
    let array = this.state.projectClass
    let formData = new FormData()
    const newProjectClass = []

    let nonPoForm = {
      status: 'For Approval',
      vendor: this.state.vendor,
      department: this.state.requestingDepartment,
      particulars: this.state.particulars,
      project: this.state.project,
      subProject: this.state.subProject,
      projectClasses: this.state.newProjectClass,
      poNumber: this.state.poNumber
    }

    formData.set('crfForm', JSON.stringify(nonPoForm))
    formData.append('supportingDocuments', this.state.file)

    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/reSubmit/${this.props.match.params.id}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        this.setState({
          redirect: true,
          crfId: `/CheckRequest/${this.props.requestId}`
        })
        console.log(this.state.redirect)
        window.location.reload()
      })
      .catch(error => {
        console.log(error.response)
        document.getElementById('errorHintResubmission').style.display = 'block'
        document.getElementById('errorHintResubmissionText').innerText =
          ' ' +
          'Please make sure you filled up the required fields at Project Class' +
          ' ' +
          (parseInt(error.response.data.Error.slice(-1)) + 1)
      })
  }

  // ==========================================Change Field Values =============================================

  // handleChangeProjectClassValue = (e) =>{
  //   console.log(e.target.name)
  //   let projectClassCopy = [...this.state.newProjectClass]
  //       projectClassCopy[e.target.id][e.target.name] = e.target.value
  //   console.log(projectClassCopy[e.target.id][e.target.name])
  //   }

  handleChangeProjectClassValue = e => {
    let projectClassCopy = [...this.state.newProjectClass]
    console.log(e.target.value)
    projectClassCopy[e.target.id[0]][e.target.name] = e.target.value

    // EXTRACT GL ACCOUNT CODE
    let glAccountValue = ''
    if (e.target.name === 'glAccount') {
      glAccountValue = e.target.value
      console.log(glAccountValue.substring(0, 10))
      projectClassCopy[e.target.id[0]].glAccount = glAccountValue.substring(
        0,
        10
      )
      console.log(this.state.newProjectClass)
    }

    // CHANGE GL NAME LISTS
    if (e.target.value === 'COC Expenses') {
      document
        .getElementById(`${e.target.id[0]}`)
        .nextElementSibling.nextElementSibling.nextElementSibling.setAttribute(
          'list',
          'cocExpenses'
        )
    }

    if (e.target.value === 'Advances') {
      document
        .getElementById(`${e.target.id[0]}`)
        .nextElementSibling.nextElementSibling.nextElementSibling.setAttribute(
          'list',
          'advances'
        )
    }

    if (e.target.value === 'Admin Expenses') {
      document
        .getElementById(`${e.target.id[0]}`)
        .nextElementSibling.nextElementSibling.nextElementSibling.setAttribute(
          'list',
          'adminExpenses'
        )
    }

    if (e.target.value === 'PPE Accounts') {
      document
        .getElementById(`${e.target.id[0]}`)
        .nextElementSibling.nextElementSibling.nextElementSibling.setAttribute(
          'list',
          'ppeAccounts'
        )
    }

    if (e.target.name === 'glCategory') {
      e.target.nextElementSibling.nextElementSibling.nextElementSibling.value =
        ''
      e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.children[1].value =
        ''

      if (e.target.value === 'Advances') {
        document.getElementsByClassName('projectClassEditDiv')[
          e.target.id
        ].style.display = 'block'
      } else {
        document.getElementsByClassName('projectClassEditDiv')[
          e.target.id
        ].style.display = 'none'
      }

      document.getElementById(
        `${e.target.id[0]}`
      ).nextElementSibling.nextElementSibling.value = ''
      projectClassCopy[e.target.id[0]].glAccount = ''
      projectClassCopy[e.target.id[0]].projectClass = ''
      // CHANGE PROJECT CLASS LOOP
      // for (let i = 0; i < projectClassCopy.length; i++) {
      //   console.log('test')
      //   projectClassCopy[i].glAccount = ""
      // }
    }

    //   if(e.target.name === "quantity" || e.target.name === "grossPricePerItem"){
    //     projectClassCopy[e.target.id[0]][e.target.name] = parseFloat(e.target.value)
    //     this.setState({newProjectClass: projectClassCopy})
    // }

    // ==========================================================================
    //ITEM NUMBER DATALIST
    // axios({
    //   method: 'GET',
    //   url: `${process.env.REACT_APP_API_KEY}/api/itemNo/DC`,
    //   headers: {
    //     'Api-Key':
    //       '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
    //     Authorization: `Bearer ${localStorage.token}`
    //   }
    // })
    //   .then(response => {
    //     console.log(response)
    // })
    // .catch(error => {
    //     console.log(error.response)
    //   })

    // this.setState({
    //   newProjectClass: projectClassCopy
    // })
    if (e.target.name === 'vatType') {
      // projectClassCopy[e.target.id[0]].wTaxTypeValue = wTaxRate * 0.01
      projectClassCopy[e.target.id[0]].wTax =
        projectClassCopy[e.target.id[0]].unitPrice *
        projectClassCopy[e.target.id[0]].wTaxTypeValue
      projectClassCopy[e.target.id[0]].netPricePerItem =
        projectClassCopy[e.target.id[0]].grossPricePerItem -
        projectClassCopy[e.target.id[0]].wTax
      this.setState({
        newProjectClass: projectClassCopy
      })
    }

    if (e.target.name === 'wTaxType') {
      console.log(this.state.wTaxRates)
      let wTaxRate = parseInt(
        this.state.wTaxRates.filter(rate => rate.wTaxCode === e.target.value)[0]
          .rate
      )
      projectClassCopy[parseInt(e.target.id)].wTaxTypeValue = wTaxRate * 0.01
      projectClassCopy[parseInt(e.target.id)].wTax =
        projectClassCopy[parseInt(e.target.id)].unitPrice *
        projectClassCopy[parseInt(e.target.id)].wTaxTypeValue
      projectClassCopy[parseInt(e.target.id)].netPricePerItem =
        projectClassCopy[parseInt(e.target.id)].grossPricePerItem -
        projectClassCopy[parseInt(e.target.id)].wTax
      // console.log(this.state.wTaxRates.filter(rate => rate.wTaxCode === e.target.value)[0].rate)
      this.setState({
        newProjectClass: projectClassCopy
      })
    }

    // if(e.target.name === 'glCategory' && e.target.value === "Advances"){
    //   e.target.nextElementSibling.nextElementSibling.nextElementSibling.style.display = 'block'
    //   e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.style.display = 'block'
    // }else if(e.target.name === 'glCategory' && e.target.value !== "Advances"){
    //   e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling.style.display = 'none'
    //   e.target.nextElementSibling.nextElementSibling.nextElementSibling.style.display = 'none'
    // console.log(e.target.nextElementSibling.nextElementSibling.nextElementSibling.nextElementSibling)
    // }

    // GET THE VAT TYPE VALUE

    projectClassCopy[e.target.id[0]].vatType === 'Goods IVAT-G' ||
      projectClassCopy[e.target.id[0]].vatType === 'Services IVAT-S'
      ? (projectClassCopy[e.target.id[0]].vatTypeValue = 1 + 0.12)
      : (projectClassCopy[e.target.id[0]].vatTypeValue = 1)

    //  THIS IS THE COMPUTATION FOR SUB TOTAL GROSS PRICE AND UNIT PRICE
    // GET UNIT PRICE

    let unitPriceToFix =
      parseFloat(projectClassCopy[e.target.id[0]].grossPricePerItem) /
      projectClassCopy[e.target.id[0]].vatTypeValue
    let unitPriceFixed = unitPriceToFix.toFixed(2)
    projectClassCopy[e.target.id[0]].unitPrice = parseFloat(unitPriceFixed)

    // GET WTAX
    // if(projectClassCopy[e.target.id[0]].unitPrice !== NaN &&
    //   projectClassCopy[e.target.id[0]].unitPrice !== 0 &&
    //   projectClassCopy[e.target.id[0]].wTaxTypeValue !== NaN &&
    //   projectClassCopy[e.target.id[0]].wTaxTypeValue !== 0){
    //     projectClassCopy[e.target.id[0]].wTax =
    //     projectClassCopy[e.target.id[0]].unitPrice *
    //     projectClassCopy[e.target.id[0]].wTaxTypeValue
    // }

    // GET NET PRICE PER ITEM
    // if(projectClassCopy[e.target.id[0]].wTax !== NaN &&
    //   projectClassCopy[e.target.id[0]].wTax !== 0){
    //     projectClassCopy[e.target.id[0]].netPricePerItem =
    //     projectClassCopy[e.target.id[0]].grossPricePerItem -
    //     projectClassCopy[e.target.id[0]].wTax
    //   }

    //GET SUBNET PRICE PER ITEM
    projectClassCopy[e.target.id[0]].subNetPrice =
      projectClassCopy[e.target.id[0]].netPricePerItem *
      projectClassCopy[e.target.id[0]].quantity

    // THIS WILL COMPUTE IN TOTAL GROSS PRICE AND TOTAL NET PRICE IN PAGE 2 OF FORM
    // console.log(document.getElementsByClassName("subTotalGrossPrice"))
    // let subTotalGrossPrice = document.getElementsByClassName("subTotalGrossPrice")
    // let subTotalNetPrice = document.getElementsByClassName("subTotalNetPrice")
    // let requestingGrossPrice = document.getElementById("requestingGrossPrice")
    // let requestingAmount = document.getElementById("requestingAmount")
    // let requestingGrossPriceValue = 0
    // let requestingAmountValue = 0
    // for (let i = 0; i < this.state.projectClass.length; i++) {
    //   subTotalGrossPrice[i].innerText = (projectClassCopy[i].grossPricePerItem *
    //       projectClassCopy[i].quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    //   requestingGrossPriceValue = requestingGrossPriceValue + (projectClassCopy[i].grossPricePerItem *
    //   projectClassCopy[i].quantity)

    //   subTotalNetPrice[i].innerText = (projectClassCopy[i].netPricePerItem *
    //       projectClassCopy[i].quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    //   requestingAmountValue = requestingAmountValue + (projectClassCopy[i].netPricePerItem *
    //     projectClassCopy[i].quantity)
    // }

    // requestingGrossPrice.innerText = (requestingGrossPriceValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    // requestingAmount.innerText = (requestingAmountValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')

    let subTotalGrossPrice = document.getElementsByClassName('newBreakDown1')
    let subTotalNetPrice = document.getElementsByClassName('newBreakDown2')
    let requestingGrossPrice = document.getElementById(
      'finalComputationTotalGrossPrice'
    )
    let requestingAmount = document.getElementById(
      'finalComputationTotalNetPrice'
    )
    let requestingGrossPriceValue = 0
    let requestingAmountValue = 0

    for (let i = 0; i < this.state.newProjectClass.length; i++) {
      subTotalGrossPrice[i].innerText = parseFloat(
        this.state.newProjectClass[i].grossPricePerItem *
        this.state.newProjectClass[i].quantity
      )
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
      requestingGrossPriceValue =
        requestingGrossPriceValue +
        projectClassCopy[i].grossPricePerItem * projectClassCopy[i].quantity

      subTotalNetPrice[i].innerText =
        // (projectClassCopy[i].netPricePerItem *
        //   projectClassCopy[i].quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        parseFloat(
          (this.state.newProjectClass[i].grossPricePerItem -
            this.state.newProjectClass[i].wTax) *
          this.state.newProjectClass[i].quantity
        )
          .toFixed(2)
          .replace(/\d(?=(\d{3})+\.)/g, '$&,')

      requestingAmountValue =
        requestingAmountValue +
        projectClassCopy[i].netPricePerItem * projectClassCopy[i].quantity
    }

    let requestingAmountValue2 = 0

    for (let index = 0; index < subTotalNetPrice.length; index++) {
      requestingAmountValue2 =
        requestingAmountValue + parseFloat(subTotalNetPrice[index].innerText)
    }

    requestingGrossPrice.innerText = requestingGrossPriceValue
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&,')
    requestingAmount.innerText = requestingAmountValue2
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&,')

    this.setState({
      newProjectClass: projectClassCopy
    })
  }

  handlePageSelected = e => {
    console.log(e.target.value)
    this.setState({
      pageSelected: parseInt(e.target.value * 5 - 1)
    })
    console.log(
      this.state.projectClass.slice(
        parseInt(e.target.value) - 4,
        parseInt(e.target.value) + 1
      )
    )
  }

  // END EVENT HANDLER
  handleInitialValue = () => {
    console.log(document.getElementsByClassName('glNameClassEdit')[1])
    // for (let i = 0; i < document.getElementsByClassName('glCategoryInitialValue').length; i++) {
    //   let element = document.getElementsByClassName('glCategoryInitialValue')[i]
    //   console.log(element.parentNode.value)

    for (let i = 0; i < this.state.projectClass.length; i++) {
      console.log(i)

      if (document.getElementsByClassName('glNameClassEdit')[i] !== undefined) {
        document.getElementsByClassName('glNameClassEdit')[i].value =
          this.state.projectClass[i].glAccount.accountCode +
          ' ' +
          this.state.projectClass[i].glAccount.accountName
      }
    }
  }

  handleEditCrf = () => {
    console.log(this.state.projectClass)
    console.log(this.state.newProjectClass)
    this.setState({
      editCrfDetails: !this.state.editCrfDetails
    })

    if (!this.state.editCrfDetails) {
      document.getElementById('mainPanel').style.marginLeft = '180px'
      document.getElementById('crfHeaderContent').style.marginLeft = '70px'
      document.getElementById('returnMessageContainer').style.marginLeft =
        '70px'
      console.log(
        document.getElementsByClassName('addProjectClassBtnContainer')[0]
      )
    } else {
      window.location.reload()
    }

    // if(this.state.requestType === "PO Item"){
    //   document.getElementById('poInputContainer').style.display ="block"
    //   document.getElementById('unEditablePoDetail').style.display ="none"
    // }

    // document.getElementById('projClassEditableField').style.display = 'block'
    // document.getElementById('projClassNonEditableField').style.display = 'none'

    // for (let i = 0; i < document.getElementsByName('vatTypeInitialValue').length; i++) {
    //     document.getElementsByName('vatTypeInitialValue')[i].innerText = this.state.projectClass[i].vatType
    //     document.getElementsByName('vatTypeInitialValue')[i].value = this.state.projectClass[i].vatType
    // }

    // for (let i = 0; i < document.getElementsByName('wTaxTypeInitialValue').length; i++) {
    //   document.getElementsByName('wTaxTypeInitialValue')[i].innerText = this.state.projectClass[i].wTaxName
    //   + " " + this.state.projectClass[i].wTaxCode
    //   document.getElementsByName('wTaxTypeInitialValue')[i].value = this.state.projectClass[i].wTaxCode
    // }

    // INITIAL VALUE FOR GL Category, Account Code / Account Name Inputs  &  Project Class Inputs
    for (
      let i = 0;
      i < document.getElementsByClassName('glCategoryInitialValue').length;
      i++
    ) {
      let element = document.getElementsByClassName('glCategoryInitialValue')[i]
      console.log(element.parentNode.value)
      document.getElementsByClassName('newBreakdown')[i].style.display = 'block'

      document.getElementsByClassName('projClassEditForm1')[i].style.display =
        'block'
      document.getElementsByClassName('projClassEditForm2')[i].style.display =
        'none'
      document.getElementsByClassName('projClassEditFormNext1')[
        i
      ].style.display = 'block'
      document.getElementsByClassName('projClassEditFormNext2')[
        i
      ].style.display = 'none'

      document.getElementsByClassName('glCategoryInitialValue')[
        i
      ].innerText = this.state.projectClass[i].glAccount.accountType

      // CHANGE GL NAME LISTS
      if (this.state.projectClass[i].glAccount.accountType === 'COC Expenses') {
        document
          .getElementsByName('glAccount')
        [i].setAttribute('list', 'cocExpenses')
      }

      if (this.state.projectClass[i].glAccount.accountType === 'Advances') {
        document
          .getElementsByName('glAccount')
        [i].setAttribute('list', 'advances')
      }

      if (
        this.state.projectClass[i].glAccount.accountType === 'Admin Expenses'
      ) {
        document
          .getElementsByName('glAccount')
        [i].setAttribute('list', 'adminExpenses')
      }

      if (this.state.projectClass[i].glAccount.accountType === 'PPE Accounts') {
        document
          .getElementsByName('glAccount')
        [i].setAttribute('list', 'ppeAccounts')
      }

      document.getElementsByName('glAccount')[i].value =
        this.state.projectClass[i].glAccount.accountCode +
        ' ' +
        this.state.projectClass[i].glAccount.accountName

      document.getElementsByName('projectClass')[
        i
      ].value = this.state.projectClass[i].glAccount.centerName
      if (this.state.projectClass[i].glAccount.accountType !== 'Advances') {
        document.getElementsByClassName('projectClassEditDiv')[
          i
        ].style.display = 'none'
      }

      document.getElementsByClassName('newBreakDown1')[
        i
      ].innerText = parseFloat(
        this.state.projectClass[i].quantity *
        this.state.projectClass[i].grossPricePerItem
      )
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
      document.getElementsByClassName('newBreakDown2')[
        i
      ].innerText = parseFloat(
        this.state.projectClass[i].quantity *
        (this.state.projectClass[i].grossPricePerItem -
          this.state.projectClass[i].apv.wTax)
      )
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')

      document.getElementsByName('quantity')[i].value = this.state.projectClass[
        i
      ].quantity
      if (this.state.requestType === 'PO Item') {
        document.getElementsByName('itemCode')[
          i
        ].value = this.state.projectClass[i].itemCode
      }
      document.getElementsByName('description1')[
        i
      ].value = this.state.projectClass[i].description1
      document.getElementsByName('description2')[
        i
      ].value = this.state.projectClass[i].description2
      document.getElementsByName('grossPricePerItem')[
        i
      ].value = this.state.projectClass[i].grossPricePerItem

      if (this.state.requestType === 'Non PO Item') {
        document.getElementsByName('quantity')[
          i
        ].value = this.state.projectClass[i].quantity
      }
    }

    //////////////////////////////////////////////////////////////////////////////////////////////////

    // for (let i = 0; i < document.getElementsByName('glAccount').length; i++) {
    //       document.getElementsByName('glAccount')[i].value =
    //        this.state.projectClass[i].glAccount.accountCode + " " +
    //        this.state.projectClass[i].glAccount.accountName
    // }

    //     for (let i = 0; i < this.state.projectClass.length; i++) {
    //       document.getElementsByName('glAccount')[i].value =
    //        this.state.projectClass[i].glAccount.accountCode + " " +
    //        this.state.projectClass[i].glAccount.accountName
    // }

    // for (let i = 0; i < this.state.projectClass.length; i++) {
    //   document.getElementsByName('glAccount')[i].value =
    //   this.state.projectClass[i].glAccount.accountCode + " " +
    //   this.state.projectClass[i].glAccount.accountName
    // }

    // console.log('test')
    // document.getElementById("approverBtnFieldResubmit").style.display = "inline"
    // document.getElementById("approverBtnFieldResubmit2").style.display = "inline"
    // document.getElementById('projectClassResubmitForm').style.display = "block"
    // let projectClassContainer = document.getElementsByClassName('projectClassListContainer')
    // console.log(this.state.projectClass)
    // console.log(document.getElementsByName('glCategory')[0])
    // for (let i = 0; i < this.state.projectClass.length; i++) {
    //   console.log(i)

    //   if(this.state.projectClass[i].glAccount.accountType !== "Advances"){
    //     document.getElementsByName('projectClass')[i].style.display = 'none'
    //     document.getElementsByName('projectClassLabel')[i].style.display = 'none'
    //     document.getElementsByClassName('glNameClass')[i].setAttribute('list', 'advances')
    //   }

    //   if(this.state.projectClass[i].glAccount.accountType === "Advances"){
    //       document.getElementsByName('projectClass')[i].setAttribute('list', 'projectClass')
    //       document.getElementsByName('projectClass')[i].value = this.state.projectClass[i].glAccount.centerName
    //     }

    //   if(this.state.projectClass[i].glAccount.accountType === "COC Expenses"){
    //     document.getElementsByClassName('glNameClass')[i].setAttribute('list', 'ppeAccounts')
    //     console.log(document.getElementsByClassName('glNameClass')[i])
    //   }

    //   if(this.state.projectClass[i].glAccount.accountType === "PPE Accounts"){
    //     document.getElementsByClassName('glNameClass')[i].setAttribute('list', 'ppeAccounts')
    //     console.log(document.getElementsByClassName('glNameClass')[i])
    //   }

    //   if(this.state.projectClass[i].glAccount.accountType === "Admin Expenses"){
    //     document.getElementsByClassName('glNameClass')[i].setAttribute('list', 'adminExpenses')
    //     console.log(document.getElementsByClassName('glNameClass')[i])
    //   }

    //   document.getElementsByName('description1')[i].value = this.state.projectClass[i].description1
    //   document.getElementsByName('description2')[i].value = this.state.projectClass[i].description2
    //   document.getElementsByName('grossPricePerItem')[i].value = this.state.projectClass[i].grossPricePerItem

    //   document.getElementsByName('wTaxTypeInitialValue')[i].innerText = this.state.projectClass[i].wTaxType
    //   document.getElementsByName('wTaxTypeInitialValue')[i].value = this.state.projectClass[i].wTaxCode
    // }
  }

  handleRemoveProjectClass = e => {
    e.preventDefault()
    console.log(e.target.id)
    let projectClassCopy = this.state.projectClass
    let newProjectClassCopy = this.state.newProjectClass

    newProjectClassCopy.splice(e.target.id, 1)
    projectClassCopy.splice(e.target.id, 1)

    this.setState({
      projectClass: projectClassCopy,
      newProjectClass: newProjectClassCopy
    })
    console.log(newProjectClassCopy)

    for (let i = 0; i < newProjectClassCopy.length; i++) {
      //  document.getElementsByName('glCategory')[i].value = newProjectClassCopy[i].glCategory
      document.getElementsByName('glAccount')[i].value =
        newProjectClassCopy[i].glAccount +
        ' ' +
        projectClassCopy[i].glAccount.accountName
      document.getElementsByName('projectClass')[i].value =
        newProjectClassCopy[i].projectClass
      document.getElementsByName('description1')[i].value =
        newProjectClassCopy[i].description1
      document.getElementsByName('description2')[i].value =
        newProjectClassCopy[i].description2
      document.getElementsByName('grossPricePerItem')[i].value =
        newProjectClassCopy[i].grossPricePerItem
      document.getElementsByClassName('newBreakDown1')[i].innerText = (
        newProjectClassCopy[i].grossPricePerItem *
        newProjectClassCopy[i].quantity
      )
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
      document.getElementsByClassName('newBreakDown2')[
        i
      ].innerText = newProjectClassCopy[i].netPricePerItem
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,')
      //  document.getElementsByName('wTax')[i].value = newProjectClassCopy[i].wTax
    }
  }

  addProjectClass = e => {
    // console.log(this.state.projectClass)
    e.preventDefault()
    this.setState({
      projectClass: [
        ...this.state.projectClass,
        {
          glAccount: {
            _id: '5deda1be1f6449140cd16c44',
            accountType: 'Advances',
            accountCode: '1080-01-09',
            accountName: 'Advances to FSMI',
            centerCode: 'EW002001',
            centerName: 'Electrical Works Mat'
          },
          description1: 'Replenishments of Office Supplies',
          description2: '',
          grossPricePerItem: 592,
          itemCode: 'N/A',
          quantity: 1,
          costType: '1OV',
          vatType: 'None IVAT-X1',
          wTaxCode: 'X1',
          wTaxName: 'None',
          wTaxType: 'None (X1)',

          apv: {
            unitPrice: 592,
            vat: 0,
            wTax: 0,
            netPricePerItem: 592,
            subTotalNetPrice: 592,
            subTotalGrossPrice: 592
          }
        }
      ],
      newProjectClass: [
        ...this.state.newProjectClass,
        {
          glCategory: '',
          glAccount: '',
          description1: '',
          description2: '',
          itemNumber: '',
          grossPricePerItem: 0,
          netPricePerItem: 0,
          quantity: 1,
          costType: '1OV',
          vatType: '',
          vatTypeValue: 1,
          wTax: 0,
          wTaxType: 'X1',
          wTaxTypeValue: 0,
          wTaxTypeString: '',
          unitPrice: 0,
          subNetPrice: 0,
          projectClass: ''
        }
      ]
    })
  }

  componentDidUpdate() {
    // console.log(this.state.newProjectClass)
    // if(this.state.editCrfDetails){
    //   for (let i = 0; i < this.state.newProjectClass.length; i++) {
    //     document.getElementsByClassName('projClassEditForm1')[i].style.display = 'block'
    //     document.getElementsByClassName('projClassEditForm2')[i].style.display = 'none'
    //     document.getElementsByClassName('newBreakdown')[i].style.display = 'block'
    //     document.getElementsByClassName('projClassEditFormNext1')[i].style.display = 'block'
    //     document.getElementsByClassName('projClassEditFormNext2')[i].style.display = 'none'
    //   }
    //   console.log(this.state.newProjectClass)
    // }
  }

  // ==============================================================================================
  formatDate = date => {
    if (!date) {
      return 'Loading...'
    }
    const dateArray = date.split('-')
    let month = dateArray[1]
    const day = dateArray[2].substring(0, 2)
    const year = dateArray[0]
    switch (dateArray[1]) {
      case '02':
        month = 'Feb'
        break
      case '03':
        month = 'Mar'
        break
      case '04':
        month = 'Apr'
        break
      case '05':
        month = 'May'
        break
      case '06':
        month = 'Jun'
        break
      case '07':
        month = 'Jul'
        break
      case '08':
        month = 'Aug'
        break
      case '09':
        month = 'Sep'
        break
      case '10':
        month = 'Oct'
        break
      case '11':
        month = 'Nov'
        break
      case '12':
        month = 'Dec'
        break
      default:
        month = 'Jan'
    }
    return `${month} ${day}, ${year}`
  }

  addQueue = (crfNo, amountRequested, dateCreated) => {
    axios({
      method: 'POST',
      url: `${process.env.REACT_APP_API_KEY}/api/inQueue`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      },
      data: {
        crfNo,
        dateCreated,
        amountRequested
      }
    })
      .then(response => {
        if (response.data.data) {
          console.log(response.data.data)
          this.setState({ addToQueue: false })
        }
      })
      .catch(error => {
        alert('Oops something went wrong')
        console.log(error.response)
      })
  }

  render() {
    console.log(this.state.crfNo)
    console.log(this.state.grandTotalNetPrice)
    console.log(this.state.creationDate)
    // setTimeout(() => this.handleInitialValue(), 1000);

    // ===================VAT TYPE SELECTIONS ===========================================================

    let vatTypeSelections = ''
    if (this.state.vatTypeSelector == '') {
      vatTypeSelections = (
        <>
          {/* <option value="" disabled selected hidden>Please Choose...</option> */}
          <option value='None IVAT-X1'>None IVAT-X1</option>
          <option value='Goods IVAT-G'>Goods IVAT-G</option>
          <option value='Services IVAT-S'>Services IVAT-S</option>
        </>
      )
    } else if (this.state.vatTypeSelector == 'IVAT-G') {
      vatTypeSelections = (
        <>
          {/* <option value="" disabled selected hidden>Please Choose...</option> */}
          <option value='None IVAT-X1'>None IVAT-X1</option>
          <option value='Goods IVAT-G'>Goods IVAT-G</option>
        </>
      )
      // for (let i = 0; i < this.state.projectClass.length; i++) {
      //   this.state.projectClass[i].vatType = "Goods IVAT-G"
      // }
      // console.log(this.state.projectClass)
    } else if (this.state.vatTypeSelector == 'IVAT-S') {
      vatTypeSelections = (
        <>
          {/* <option value="" disabled selected hidden>Please Choose...</option> */}
          <option value='None IVAT-X1'>None IVAT-X1</option>
          <option value='Services IVAT-S'>Services IVAT-S</option>
        </>
      )
      // for (let i = 0; i < this.state.projectClass.length; i++) {
      //   this.state.projectClass[i].vatType = "Services IVAT-S"
      // }
      // console.log(this.state.projectClass)
    } else if (this.state.vatTypeSelector == 'X1') {
      vatTypeSelections = (
        <>
          <option value='None IVAT-X1'>None IVAT-X1</option>
        </>
      )
      for (let i = 0; i < this.state.projectClass.length; i++) {
        this.state.projectClass[i].vatType = 'None IVAT-X1'
      }
      // console.log(this.state.projectClass)
    }

    // =================END VAT TYPE SELECTIONS ===========================================================

    let stateArray = []
    let projectClassArray = []
    let totalNetPrice = 0
    let totalGrossPrice = 0

    // let approveBtn = ""
    // let returnBtn = ""
    // let transmittedBtn = ""
    // let reviewedBtn = ""
    // let endorsementBtn = ""
    // let onHoldBtn = ""
    // let dlCsvBtn = ""

    let newProjectClasses = [...this.state.newProjectClass]
    console.log(this.state.newProjectClass)
    console.log(newProjectClasses)

    for (let key in this.state.projectClass) {
      stateArray.push({
        glAccount: { ...this.state.projectClass[key].glAccount },
        apv: { ...this.state.projectClass[key].apv },
        data: key
      })
    }

    for (let key in this.state.newProjectClass) {
      projectClassArray.push({
        glCategory: this.state.newProjectClass[key].glCategory,
        glAccount: this.state.newProjectClass[key].glAccount,
        // apv: {...this.state.newProjectClass[key].apv},
        data: key
      })
      // this.setState({oldProjectClass: projectClassArray})
      console.log(projectClassArray.length)
    }

    console.log(projectClassArray.length)

    for (let i = 0; i < stateArray; i++) {
      totalNetPrice = totalNetPrice + stateArray[i].apv.subTotalNetPrice

      totalGrossPrice = totalGrossPrice + stateArray[i].apv.subTotalGrossPrice
    }
    let toFixed = totalNetPrice.toFixed(2)

    console.log(this.state.newProjectClass)

    // == PAGINATION FUNCTION ===============================================================================================
    let pages = []
    console.log(this.state.newProjectClass)
    // console.log((this.state.newProjectClass).length / 5  - parseInt((this.state.newProjectClass).length / 5 ))
    let page = this.state.newProjectClass.length / 5
    console.log(page)
    if (
      this.state.newProjectClass.length / 5 -
      parseInt(this.state.newProjectClass.length / 5) !==
      0
    ) {
      page = page + 1
    }
    for (let i = 1; i < page + 1; i++) {
      pages.push(i)
      console.log(pages)
    }

    console.log(stateArray)
    // == END PAGINATION FUNCTION ===============================================================================================

    return (
      <CrfContext.Consumer>
        {context => (
          <div id='mainPage'>
            <Backdrop open={this.state.isLoading} />
            <OrModal
              modalState={this.state.modalState}
              handleModal={this.orModal}
              crfNo={this.state.crfNo}
            />
            {/* <div></div> */}
            <Modals
              loading={this.state.loading}
              handleChangeState={this.handleChangeState}
              handleRejectRequest={this.handleRejectRequest}
              handleReturnRequest={this.handleReturnRequest}
              closeReturnModal={this.closeReturnModal}
              showReturnModal={this.handleShowReturnModal}
              handleShowOnHoldModal={this.handleShowOnHoldModal}
              crfLink={this.state.crfLink}
              onHoldRequest={this.state.onHoldRequest}
              endorseRequest={this.state.endorseRequest}
              reviewRequest={this.state.reviewRequest}
              transmitRequest={this.state.transmitRequest}
              rejectRequest={this.state.rejectRequest}
              returnRequest={this.state.returnRequest}
              approveRequest={this.state.approveRequest}
              compApproveRequest={this.state.compApproveRequest}
              cooApproveRequest={this.state.cooApproveRequest}
              handleApproveCrf={this.handleApproveCrf}
              handleCompApproveCrf={this.handleCompApproveCrf}
              handleCooApproveCrf={this.handleCooApproveCrf}
              handleTransmitted={this.handleTransmitted}
              handleReviewed={this.handleReviewed}
              handleInprocess={this.handleInprocess}
              handleOnHold={this.handleOnHold}
            />
            <div id='sidePanel'>
              <SideNav />
            </div>
            <div id='mainPanel'>
              {/* CONTAINER 1 */}
              <div className='crfHeader'>
                <div
                  className='crfHeaderContent'
                  id='crfHeaderContent'
                  style={{ borderBottom: '1px solid black' }}
                >
                  <div className='crfHead1'>
                    <h1>CRF#{' ' + this.state.crfNo}</h1>
                    <h5>Request Type:{' ' + this.state.requestType}</h5>

                    {this.state.requestType === 'PO Item' ? (
                      <>
                        <h5 id='unEditablePoDetail'>
                          PO number: {this.state.poNumber}
                        </h5>
                        <div id='poInputContainer'>
                          <span className='EditableVendorLabel'>
                            PO Number:<span style={errorChecker}>*</span>
                          </span>
                          <input
                            type='number'
                            name='poNumber'
                            id='poInput'
                            className='editCrfInput'
                            onChange={this.handleChangeRequestField}
                            placeholder='Required'
                            autoComplete='off'
                            value={this.state.poNumber}
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                  <div className='crfHead2'>
                    {/* ===== STATUS FLASH MESSAGES */}
                    {this.state.status === 'For Approval' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        {context.state.userRole === 'Requestor' ? (
                          <h6>
                            Please wait for the approval of your department
                            head.
                          </h6>
                        ) : null}
                      </div>
                    ) : null}

                    {this.state.status === 'For Comptroller Approval' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        {context.state.userRole === 'Requestor' ? (
                          <h6>
                            Please wait for the approval of your department
                            head.
                          </h6>
                        ) : null}
                      </div>
                    ) : null}

                    {this.state.status === 'For COO Approval' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        {context.state.userRole === 'Requestor' ? (
                          <h6>
                            Please wait for the approval of your department
                            head.
                          </h6>
                        ) : null}
                      </div>
                    ) : null}

                    {this.state.status === 'For Transmittal' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        {context.state.userRole === 'Requestor' ? (
                          <h6>
                            Please make sure that the documents you uploaded
                            will be transmit.
                          </h6>
                        ) : null}
                      </div>
                    ) : null}

                    {this.state.status === 'For Review' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        {context.state.userRole === 'Requestor' ? (
                          <h6>
                            Your documents has been received by the finance
                            department and subjected to be reviewed.
                          </h6>
                        ) : null}
                      </div>
                    ) : null}

                    {this.state.status === 'For Endorsement' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        {context.state.userRole === 'Requestor' ? (
                          <h6>Your request has been reviewed.</h6>
                        ) : null}
                      </div>
                    ) : null}

                    {this.state.status === 'Rejected' ? (
                      <div style={errorChecker} className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        <h6>
                          This request has been rejected and cannot be
                          resubmitted.
                        </h6>
                      </div>
                    ) : null}

                    {this.state.status === 'On Hold' ? (
                      <div style={errorChecker} className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        <h6>
                          Please wait for Accounting to process this request.
                        </h6>
                      </div>
                    ) : null}

                    {this.state.status === 'In Process' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        {context.state.userRole === 'Requestor' ? (
                          <h6>Your request has been reviewed.</h6>
                        ) : null}
                      </div>
                    ) : null}

                    {this.state.status === 'Check Preparation' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        {/* <h6>Please wait for the finance to process this request.</h6> */}
                      </div>
                    ) : null}

                    {this.state.status === 'Check Prepared' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        <h5>Check Date: {' ' + this.state.checkDate} </h5>
                        {/* <h6>Please wait for the finance to process this request.</h6> */}
                      </div>
                    ) : null}

                    {this.state.status === 'Check Available' ? (
                      <div className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        <h5>Check Date: {' ' + this.state.checkDate} </h5>
                        <h5>Check No: {' ' + this.state.checkNo} </h5>
                        {/* <h6>Please wait for the finance to process this request.</h6> */}
                      </div>
                    ) : null}

                    {this.state.status === 'Check Released' ? (
                      <div className='containerHeader'>
                        <div className='statusMessage'>
                          <h5>Status: {' ' + this.state.status}</h5>
                          <h5>
                            Date Released:{' '}
                            {' ' +
                              `${this.state.dateReleased[1]
                              }/${this.state.dateReleased[2].substring(0, 2)}/${this.state.dateReleased[0]
                              }`}
                          </h5>
                          <h6>This request is completed.</h6>
                        </div>
                        <div
                          className='statusMessage'
                          style={{ fontSize: '12px' }}
                        >
                          {this.state.orObj === null ? (
                            <button
                              onClick={() => this.orModal()}
                              style={
                                context.state.userRole === 'Accounting Staff'
                                  ? {
                                    padding: '10px 1rem',
                                    display: 'block'
                                  }
                                  : { display: 'none' }
                              }
                            >
                              Add OR Number
                            </button>
                          ) : (
                            <>
                              <div>
                                <b>OR#:</b> {this.state.orObj.orNo}
                              </div>
                              <div>
                                <b>OR Date:</b>{' '}
                                {this.formatDate(this.state.orObj.orDate)}
                              </div>
                              <div>
                                <label>
                                  <b>Upload: </b>
                                </label>
                                <button
                                  style={{ backgroundColor: 'transparent' }}
                                  onClick={() => this.handleOrUpload()}
                                >
                                  {this.state.orObj.orUpload}
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    ) : null}

                    {/* ===== STATUS FLASH MESSAGES */}

                    {this.state.status === 'Returned' ? (
                      <div style={errorChecker} className='statusMessage'>
                        <h5>Status: {' ' + this.state.status}</h5>
                        <h6>
                          This request is editable and can be resubmitted.
                        </h6>
                        {context.state.userRole === 'Requestor' ? (
                          <div className='toggleEditableRequestContainer'>
                            <button
                              className='toggleEditableRequest'
                              type='button'
                              onClick={this.handleEditCrf}
                            >
                              <i class='fas fa-edit'></i>
                              {this.state.editCrfDetails === false
                                ? ' ' + 'Edit CRF'
                                : ' ' + 'Cancel'}
                            </button>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              {/* RETURN MESSAGE BOX */}
              {this.state.rejectionMessage ? (
                <div
                  className='returnMessageContainer'
                  id='returnMessageContainer'
                >
                  <h4 className>Remarks:</h4>
                  <h5>{this.state.rejectionMessage.message}</h5>
                </div>
              ) : (
                (document.getElementById('crfBodyContainer').style.marginTop =
                  '70px')
              )}
              {/* END OF CONTAINER 1 */}

              {this.state.editCrfDetails ? (
                <EditDetails crfId={this.props.match.params.id} />
              ) : (
                <div id='crfBodyContainer' className='crfBodyContainer'>
                  {/* CONTAINER 2 */}
                  <div className='crfBodyContent'>
                    {/* CRF CONTENT 1 */}
                    <div className='crfBody'>
                      <div className='crfDetail1'>
                        <h5>Due Date: {this.formatDate(this.state.dueDate)}</h5>
                        <h5>
                          Date Created:
                          {' ' +
                            `${this.state.creationDate}`.slice(4, 16) +
                            ' '}
                          <span>
                            Time{' '}
                            <span>
                              {`${this.state.creationDate}`.slice(16, 21)}
                            </span>
                          </span>
                        </h5>
                        <h5>Requestor: {' ' + this.state.requestor}</h5>
                        <h5>
                          Requesting Department:{' '}
                          {' ' + this.state.requestingDepartment}
                        </h5>
                        {/* EDITABLE CRF DETAILS */}

                        <div className='editableDetails' id='editableDetails'>
                          {/* == CRF DETAILS 1 ======================================================================================================================= */}

                          <div
                            className='projClassEditableField'
                            id='projClassEditableField'
                          >
                            <div
                              className='vendorEditWarning'
                              id='vendorEditWarning'
                            >
                              {/* ============== EDITABLE VENDOR INPUT =================================================================================== */}
                              <span className='EditableVendorLabel'>
                                Vendor/Payee:<span style={errorChecker}>*</span>
                              </span>
                              <input
                                type='text'
                                className='editCrfInput'
                                list='vendorListOptions'
                                id='vendorInput'
                                name='vendor'
                                onChange={this.handleChangeRequestField}
                                placeholder='Required'
                                value={this.state.vendor}
                              />
                              <small
                                className='editWarningMessage'
                                id='editWarningMessage'
                              >
                                <i class='fas fa-exclamation-triangle'> </i>
                                <span>
                                  Changing the Vendor/Payee will reset the Vat
                                  Type and Withholding Tax inputs.
                                </span>
                              </small>
                              <datalist id='vendorListOptions'>
                                {this.state.vendorLists.map(data => (
                                  <option
                                    className='vendorListData'
                                    value={data}
                                  />
                                ))}
                              </datalist>
                              {/* ============== EDITABLE PARTICULARS INPUT =================================================================================== */}
                              <span className='EditableVendorLabel'>
                                Particulars:<span style={errorChecker}>*</span>
                              </span>
                              <input
                                type='text'
                                className='editCrfInput'
                                id='particularsInput'
                                name='particulars'
                                onChange={this.handleChangeRequestField}
                                autoComplete='off'
                                placeholder='Required'
                                value={this.state.particulars}
                              />
                              <small
                                className='editWarningMessage2'
                                id='editWarningMessage2'
                              >
                                <i class='fas fa-exclamation-triangle'> </i>
                                <span></span>
                              </small>

                              {/* ============== EDITABLE PROJECT INPUT ====================================================================================== */}
                              <br />
                              <span className='EditableVendorLabel'>
                                Project:<span style={errorChecker}>*</span>
                              </span>
                              <input
                                type='text'
                                className='editCrfInput'
                                list='projectDataLists'
                                id='projectInput'
                                name='project'
                                onChange={this.handleChangeRequestField}
                                value={this.state.project}
                                placeholder='Required'
                              />
                              <small className='editWarningMessage'>
                                <i class='fas fa-exclamation-triangle'> </i>
                                <span>
                                  Changing the Project will reset the GL
                                  Category, Account Code/Account Name and
                                  Project Class inputs.
                                </span>
                              </small>
                              <datalist id='projectDataLists'>
                                {this.state.projectLists.map(data => (
                                  <option value={data} />
                                ))}
                              </datalist>

                              {/* ============== EDITABLE SUB PROJECT INPUT =================================================================================== */}
                              <br />
                              <span className='EditableVendorLabel'>
                                Sub Project:
                              </span>
                              <input
                                type='text'
                                className='editCrfInput'
                                autoComplete='off'
                                id='subProjectInput'
                                name='subProject'
                                onChange={this.handleChangeRequestField}
                                value={this.state.subProject}
                                placeholder='Optional'
                              />

                              {/* ============== CHANGEABLE FILE INPUT ======================================================================================== */}
                              <span className='EditableVendorLabel'>
                                Supporting Document:
                                <span style={errorChecker}>*</span>
                              </span>
                              <div className='supportingDoc'>
                                <i
                                  class='fas fa-file-pdf'
                                  onClick={this.handleDownloadPdf}
                                ></i>
                              </div>

                              <div
                                className='fileUploadedReturn'
                                id='fileUploadedValidation'
                              >
                                <i class='fas fa-exclamation-triangle'></i>
                                <small></small>
                              </div>

                              <label
                                htmlFor='editFileInput'
                                className='editFileInputLabel'
                              >
                                <input
                                  type='file'
                                  id='editFileInput'
                                  className='input1'
                                  accept='.pdf'
                                  name='file'
                                  onChange={this.handleChangeRequestField}
                                />
                                <small className='editWarningMessage'>
                                  <i class='fas fa-exclamation-triangle'> </i>
                                  <span>
                                    Changing the Project will reset the GL
                                    Category, Account Code/Account Name and
                                    Project Class inputs.
                                  </span>
                                </small>
                                Change
                              </label>
                            </div>
                          </div>

                          <div id='projClassNonEditableField'>
                            <h5>Vendor/Payee:{' ' + this.state.vendor}</h5>
                            <h5>Particulars: {' ' + this.state.particulars}</h5>
                            <h5>Project:{' ' + this.state.project}</h5>
                            <h5>Sub Project: {' ' + this.state.subProject}</h5>
                            <div className='currentFilePdfContainer'>
                              <button
                                className='currentFilePdf'
                                type='button'
                                onClick={this.handleDownloadPdf}
                              >
                                <i class='fas fa-file-pdf'></i> View Attached
                                file
                              </button>
                            </div>
                          </div>

                          {/* === END CRF DETAILS =========================================================================================================================== */}
                        </div>

                        {/* // ==================================== RESUBMIT FORM ============================================================ */}

                        {/* ===================== END of RESUBMIT FORM =========================================================== */}
                      </div>
                      <div className='crfDetail2'>
                        <h5>Work Flow</h5>
                        {this.state.status === 'Rejected' ||
                          this.state.status === 'Returned' ? (
                          <>
                            {this.state.rejectionMessage.role ===
                              'Department Head' ? (
                              <>
                                <div className='workFlowContainer'>
                                  <img
                                    className='workFlow'
                                    src={ForApprovalImg}
                                    alt=''
                                  />
                                </div>
                                <div className='workFlowContainer'>
                                  <img
                                    className='workFlow2'
                                    src={PhaseTwoInactive}
                                    alt=''
                                  />
                                </div>
                              </>
                            ) : null}
                          </>
                        ) : null}

                        {this.state.status === 'Rejected' ||
                          this.state.status === 'Returned' ? (
                          <>
                            {this.state.rejectionMessage.role ===
                              'Accounting Staff' ? (
                              <>
                                <div className='workFlowContainer'>
                                  <img
                                    className='workFlow'
                                    src={ForReviewImg}
                                    alt=''
                                  />
                                </div>
                                <div className='workFlowContainer'>
                                  <img
                                    className='workFlow2'
                                    src={PhaseTwoInactive}
                                    alt=''
                                  />
                                </div>
                              </>
                            ) : null}
                          </>
                        ) : null}

                        {/* {this.state.rejectionMessage !== null ?
                       <>
                          {this.state.rejectionMessage.role === "Accounting Staff" ?
                         <>
                         <div className="workFlowContainer">
                           <img className="workFlow" src={ForReviewImg} alt=""/>
                         </div>
                         <div className="workFlowContainer">
                           <img className="workFlow2" src={PhaseTwoInactive} alt=""/>
                         </div>
                         </>
                       : null}
                       </>
                      : null} */}

                        {this.state.status === 'For Approval' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={ForApprovalImg}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={PhaseTwoInactive}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'For Comptroller Approval' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={ForApprovalImg}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={PhaseTwoInactive}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'For COO Approval' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={ForApprovalImg}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={PhaseTwoInactive}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'For Transmittal' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={ForTransmittalImg}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={PhaseTwoInactive}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {/* ===================================================================================================================================== */}

                        {/* {this.state.rejectionMessage !== null ?
                       <>
                         {this.state.rejectionMessage.role === "Department Head" && this.state.status === "Returned" ?
                          <>
                          <div className="workFlowContainer">
                            <img className="workFlow" src={ForApprovalImg} alt=""/>
                          </div>
                          <div className="workFlowContainer">
                            <img className="workFlow2" src={PhaseTwoInactive} alt=""/>
                          </div>
                          </>
                       : null} */}

                        {/* ====================================================================================================================================== */}
                        {/* {this.state.status === "For Transmittal" ?
                          <>
                          <div className="workFlowContainer">
                            <img className="workFlow" src={ForTransmittalImg} alt=""/>
                          </div>
                          <div className="workFlowContainer">
                            <img className="workFlow2" src={PhaseTwoInactive} alt=""/>
                          </div>
                          </>
                       : null}

                        {this.state.status === "For Review" ?
                          <>
                          <div className="workFlowContainer">
                            <img className="workFlow" src={ForReviewImg} alt=""/>
                          </div>
                          <div className="workFlowContainer">
                            <img className="workFlow2" src={PhaseTwoInactive} alt=""/>
                          </div>
                          </>
                       : null} */}
                        {/* ===================================================================================================================================== */}
                        {/* {this.state.rejectionMessage.role === "Accounting Staff" && this.state.status === "Returned" ?
                          <>
                          <div className="workFlowContainer">
                            <img className="workFlow" src={ForReviewImg} alt=""/>
                          </div>
                          <div className="workFlowContainer">
                            <img className="workFlow2" src={PhaseTwoInactive} alt=""/>
                          </div>
                          </>
                       : null}

                     </>
                     : null} */}

                        {/* ====================================================================================================================================== */}
                        {this.state.status === 'For Review' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={ForReviewImg}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={PhaseTwoInactive}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'For Endorsement' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={ForEndorsementImg}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={PhaseTwoInactive}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'On Hold' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={ForEndorsementImg}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={PhaseTwoInactive}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'In Process' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={PhaseOneDone}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={InProcessImg}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'Check Preparation' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={PhaseOneDone}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={CheckPreparationImg}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'Check Prepared' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={PhaseOneDone}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={CheckPreparedImg}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'Check Available' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={PhaseOneDone}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={CheckAvailableImg}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}

                        {this.state.status === 'Check Released' ? (
                          <>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow'
                                src={PhaseOneDone}
                                alt=''
                              />
                            </div>
                            <div className='workFlowContainer'>
                              <img
                                className='workFlow2'
                                src={CheckReleasedImg}
                                alt=''
                              />
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                    {/*END CRF CONTENT 1 */}
                  </div>
                  <div>
                    {/* =================================================================================================== */}
                    {/* PROJECT CLASS LIST */}
                    <div className='projectClassListTools'>
                      <h5 className='projectClassListLabel'>
                        Project Class List:
                      </h5>
                      {/* <div className="paginationTool">
                   <span className="pagesTitle">Pages:</span>
                   {pages.map(pagebtn =>
                       <button onClickCapture={this.handlePageSelected} value={pagebtn} type="button">{pagebtn}</button>
                     )}
                   </div> */}
                    </div>

                    {/* == PROJECT CLASSES ============================================================================================================= */}
                    <div className='projClassesMasterContainer'>
                      {stateArray
                        // (stateArray.slice((this.state.pageSelected - 4), this.state.pageSelected + 1))
                        .map(data => (
                          <div className='projectClassListContainer'>
                            <div className='projectClassList'>
                              <div className='projClassNumber'>
                                <h5>{parseInt(data.data) + 1}</h5>
                              </div>
                              <div className='projectClassListContent1'>
                                {/* <div className="projectClassGl"> */}
                                {/* ========== RESUBMIT FORM ==============================================================================================================                                */}
                                {/* {this.state.editCrfDetails === true ?  */}
                                <div className='projClassEditForm1'>
                                  {/* ================== GL CATEGORY INPUT =============================================================================== */}
                                  <span className='projClassDetailEditable'>
                                    GL Category:
                                    <span style={errorChecker}>*</span>
                                  </span>
                                  <select
                                    className='glCategoryClassEdit'
                                    name='glCategory'
                                    id={data.data}
                                    onChange={
                                      this.handleChangeProjectClassValue
                                    }
                                  // value={data.data}
                                  >
                                    <option
                                      value={data.data}
                                      className='glCategoryInitialValue'
                                      selected
                                      hidden
                                    ></option>
                                    {this.state.accountTypes.map(data => (
                                      <option value={data}>{data}</option>
                                    ))}
                                  </select>
                                  {/* ================== END GL CATEGORY INPUT =============================================================================== */}
                                  <br />
                                  {/* ================== ACCOUNTCODE ACCOUNT NAME INPUT =============================================================================== */}
                                  <span className='projClassDetailEditable'>
                                    Account Code/Account Name:
                                    <span style={errorChecker}>*</span>
                                  </span>
                                  <input
                                    className='glNameClassEdit'
                                    type='text'
                                    name='glAccount'
                                    id={data.data}
                                    //  list="accountName"
                                    autoComplete='off'
                                    placeholder='Required'
                                    // value={data.glAccount.accountCode + " " + data.glAccount.accountName}
                                    onChange={
                                      this.handleChangeProjectClassValue
                                    }
                                  />
                                  {/* ================== PROJECT CLASS(CENTERNAME) INPUT =================================================================================== */}
                                  <br />
                                  <div className='projectClassEditDiv'>
                                    <span className='projClassDetailEditable'>
                                      Project Class:
                                      <span style={errorChecker}>*</span>
                                    </span>
                                    <input
                                      className='projectClassEdit'
                                      type='text'
                                      name='projectClass'
                                      id={data.data}
                                      list='advancesList'
                                      autoComplete='off'
                                      placeholder='Required'
                                      onChange={
                                        this.handleChangeProjectClassValue
                                      }
                                    />
                                    <datalist id='advancesList'>
                                      {this.state.advancesProjectClass.map(
                                        data => (
                                          <option value={data} />
                                        )
                                      )}
                                    </datalist>
                                  </div>

                                  {/* ================== END PROJECT CLASS(CENTERNAME) INPUT =============================================================================== */}
                                  {/* ================== DESCRIPTION 1 INPUT =================================================================================== */}
                                  <span className='projClassDetailEditable'>
                                    Description 1 :
                                    <span style={errorChecker}>*</span>
                                  </span>
                                  <input
                                    className='description1ClassEdit'
                                    type='text'
                                    name='description1'
                                    id={data.data}
                                    //  list="accountName"
                                    autoComplete='off'
                                    placeholder='Required'
                                    // value={this.state.projectClass[data.data].description1}
                                    onChange={
                                      this.handleChangeProjectClassValue
                                    }
                                  />
                                  {/* ================== END DESCRIPTION 1 INPUT =================================================================================== */}
                                  {/* ================== DESCRIPTION 2 INPUT =================================================================================== */}
                                  <br />
                                  <span className='projClassDetailEditable'>
                                    Description 2 :
                                  </span>
                                  <input
                                    className='description2ClassEdit'
                                    type='text'
                                    name='description2'
                                    id={data.data}
                                    //  list="accountName"
                                    autoComplete='off'
                                    placeholder='Optional'
                                    // value={this.state.projectClass[data.data].description2}
                                    onChange={
                                      this.handleChangeProjectClassValue
                                    }
                                  />
                                  {/* ================== END DESCRIPTION 2 INPUT =================================================================================== */}
                                  {/* ================== QUANTITY INPUT =================================================================================== */}
                                  <br />
                                  <span className='projClassDetailEditable'>
                                    Quantity:<span style={errorChecker}>*</span>
                                    {this.state.requestType === 'Non PO Item'
                                      ? ' ' +
                                      `${this.state.projectClass[data.data]
                                        .quantity
                                      }`
                                      : null}
                                  </span>
                                  <input
                                    className='quantityClassEdit'
                                    type='number'
                                    name='quantity'
                                    id={data.data}
                                    autoComplete='off'
                                    // placeholder="Required"
                                    step='any'
                                    onChange={
                                      this.handleChangeProjectClassValue
                                    }
                                    style={
                                      this.state.requestType === 'Non PO Item'
                                        ? displayNone
                                        : null
                                    }
                                  />
                                  {/* ================== END Quantity INPUT =================================================================================== */}
                                  {/* ================== ITEM CODE INPUT =================================================================================== */}
                                  {this.state.requestType === 'PO Item' ? (
                                    <>
                                      <br />
                                      <span className='projClassDetailEditable'>
                                        Item Code:
                                        <span style={errorChecker}>*</span>
                                      </span>
                                      <input
                                        className='itemCodeClassEdit'
                                        type='text'
                                        name='itemCode'
                                        id={data.data}
                                        autoComplete='off'
                                        placeholder='Required'
                                        onChange={
                                          this.handleChangeProjectClassValue
                                        }
                                        list='itemNumberList'
                                      />
                                    </>
                                  ) : null}

                                  {/* ================== END ITEM CODE INPUT =================================================================================== */}
                                  {/* ================== DESCRIPTION 2 INPUT =================================================================================== */}
                                  <br />
                                  <span className='projClassDetailEditable'>
                                    Gross Price Per Item:
                                    <span style={errorChecker}>*</span>
                                  </span>
                                  <input
                                    className='grossPricePerItemClassEdit'
                                    type='number'
                                    name='grossPricePerItem'
                                    id={data.data}
                                    //  list="accountName"
                                    autoComplete='off'
                                    placeholder='Required'
                                    // value={this.state.projectClass[data.data].grossPricePerItem}
                                    step='any'
                                    onChange={
                                      this.handleChangeProjectClassValue
                                    }
                                  />
                                  {/* {document.getElementsByClassName('grossPricePerItemClassEdit')[data.data].value
                                  = this.state.projectClass[data.data].grossPricePerItem} */}
                                  {/* ================== END DESCRIPTION 2 INPUT =================================================================================== */}
                                </div>
                                {/* : */}
                                <div className='projClassEditForm2'>
                                  <h6 className='projClassDetail'>
                                    GL Category: {data.glAccount.accountType}
                                  </h6>
                                  <h6 className='projClassDetail'>
                                    Account Code/Account Name:
                                    {data.glAccount.accountCode +
                                      ' ' +
                                      data.glAccount.accountName +
                                      ' ' +
                                      data.glAccount.centerCode}
                                  </h6>
                                  {
                                    // data.glAccount.accountType === 'Advances' ? (
                                    <h6 className='projClassDetail'>
                                      Project Class: {data.glAccount.centerName}
                                    </h6>
                                    // ) : null
                                  }
                                  <h6 className='projClassDetail'>
                                    Description1:
                                  </h6>
                                  <div className='description1Div'>
                                    <small>
                                      {
                                        this.state.projectClass[data.data]
                                          .description1
                                      }
                                    </small>
                                  </div>
                                  <h6 className='projClassDetail'>
                                    Description2:
                                  </h6>
                                  <div className='description2Div'>
                                    <small>
                                      {
                                        this.state.projectClass[data.data]
                                          .description2
                                      }
                                    </small>
                                  </div>

                                  {this.state.requestType === 'PO Item' ? (
                                    <h6 className='projClassDetail'>
                                      Item Code:
                                      {' ' +
                                        this.state.projectClass[data.data]
                                          .itemCode}
                                    </h6>
                                  ) : null}

                                  <h6 className='projClassDetail'>
                                    Quantity:
                                    {' ' +
                                      this.state.projectClass[data.data]
                                        .quantity}
                                  </h6>
                                  <h6 className='projClassDetail'>
                                    Gross Price Per Item:
                                    <span> &#8369;</span>
                                    {/* {" " + parseFloat(this.state.projectClass[data.data].grossPricePerItem)
                                   .toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} */}
                                    {parseFloat(
                                      this.state.projectClass[data.data]
                                        .grossPricePerItem
                                    )
                                      .toFixed(2)
                                      .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                  </h6>
                                </div>
                                {/* }  */}
                                {/* COC EXPENSES LIST */}
                                <datalist id='cocExpenses'>
                                  {this.state.cocExpenses.map(data => (
                                    <option value={data} />
                                  ))}
                                </datalist>
                                {/* ADVANCES LIST */}
                                <datalist id='advances'>
                                  {this.state.advances.map(data => (
                                    <option value={data} />
                                  ))}
                                </datalist>
                                {/* PPE ACCOUNTS LIST */}
                                <datalist id='ppeAccounts'>
                                  {this.state.ppeAccounts.map(data => (
                                    <option value={data} />
                                  ))}
                                </datalist>
                                {/* Admin Expenses */}
                                <datalist id='adminExpenses'>
                                  {this.state.adminExpenses.map(data => (
                                    <option value={data} />
                                  ))}
                                </datalist>
                                {/* Item Number */}
                                <datalist id='itemNumberList'>
                                  {this.state.itemNoLists.map(data => (
                                    <option value={data} />
                                  ))}
                                </datalist>

                                {/* ============== END OF RESUBMIT FORM =================================================================================================== */}
                                {/* <h4>GL Name: {data.glAccount.accountCode + " " + data.glAccount.accountName}</h4> */}
                                {/* </div> */}
                              </div>
                              <div className='projectClassListContent2'>
                                {/* <div className="qtyAnd"> */}
                                {/* </div> */}

                                <div className='projClassEditFormNext1'>
                                  {/* ================== VAT TYPE INPUT =================================================================================== */}
                                  <span className='projClassDetailEditable'>
                                    VAT Type :
                                    <span style={errorChecker}>*</span>
                                  </span>
                                  <select
                                    className='glNameClassEdit'
                                    name='vatType'
                                    id={data.data}
                                    onChange={
                                      this.handleChangeProjectClassValue
                                    }
                                  >
                                    <option
                                      value=''
                                      name='vatTypeInitialValue'
                                      className='vatTypeInitialValue'
                                      selected
                                    >
                                      {/* {this.state.projectClass[data.data].vatType} */}
                                    </option>
                                    {vatTypeSelections}
                                  </select>
                                  {/* ================== END VAT TYPE INPUT =================================================================================== */}
                                  {/* ================== VAT TYPE INPUT =================================================================================== */}
                                  <br />
                                  <span className='projClassDetailEditable'>
                                    Withholding Tax Type :
                                    <span style={errorChecker}>*</span>
                                  </span>
                                  <select
                                    className='glNameClassEdit'
                                    name='wTaxType'
                                    id={data.data}
                                    onChange={
                                      this.handleChangeProjectClassValue
                                    }
                                  >
                                    <option
                                      value=''
                                      name='wTaxTypeInitialValue'
                                      className='wTaxTypeInitialValue'
                                      selected
                                    ></option>

                                    {this.state.wTaxRates.map(
                                      data => { }
                                      // <>
                                      //    {data.wTaxCode !== "X1" ?
                                      // <option value={data?.wTaxCode}>
                                      //   {data.wTaxDisplayName +
                                      //     ' ' +
                                      //     data.wTaxCode}
                                      // </option>
                                    )
                                      //    :null}
                                      // </>
                                    }
                                  </select>
                                  {/* ================== END VAT TYPE INPUT =================================================================================== */}
                                </div>

                                <div className='projClassEditFormNext2'>
                                  <h6 className='projClassDetail'>
                                    VAT Type:
                                    {' ' +
                                      this.state.projectClass[data.data]
                                        .vatType}
                                  </h6>
                                  <h6
                                    className='projClassDetail'
                                    style={marginBottom}
                                  >
                                    Withholding Tax Type:
                                    {' ' +
                                      this.state.projectClass[data.data]
                                        .wTaxType}
                                  </h6>
                                </div>
                                {!this.state.editCrfDetails ? (
                                  <>
                                    <h4 className='breakDownHead'>
                                      Break Down:
                                    </h4>
                                    <div className='breakDown'>
                                      <div className='breakDownContent1'>
                                        <h5 className='breakDownDetail'>
                                          Sub Total Gross Price:
                                        </h5>
                                        <h5 className='breakDownDetail'>
                                          Value Added Tax:
                                        </h5>
                                        <h5 className='breakDownDetail'>
                                          Withholding Tax:
                                        </h5>
                                        <h5 className='breakDownDetail'>
                                          Sub Total Net Price:
                                        </h5>
                                      </div>
                                      <div className='breakDownContent2'>
                                        <h5 className='breakDownDetailValue'>
                                          <span>&#8369;</span>
                                          {' ' +
                                            (
                                              this.state.projectClass[data.data]
                                                .grossPricePerItem *
                                              this.state.projectClass[data.data]
                                                .quantity
                                            )
                                              .toFixed(2)
                                              .replace(
                                                /\d(?=(\d{3})+\.)/g,
                                                '$&,'
                                              )}
                                        </h5>
                                        <h5 className='breakDownDetailValue'>
                                          <span>&#8369;</span>
                                          {' ' +
                                            parseFloat(data.apv.vat)
                                              .toFixed(2)
                                              .replace(
                                                /\d(?=(\d{3})+\.)/g,
                                                '$&,'
                                              )}
                                          {/* PERCENTAGE */}
                                          {/* {((data.apv.vat / data.apv.unitPrice) * 100).toFixed(2)
                                     .replace(/\d(?=(\d{3})+\.)/g, '$&,')+ "%"} */}
                                        </h5>
                                        <h5 className='breakDownDetailValue'>
                                          <span>&#8369;</span>
                                          {' ' +
                                            parseFloat(data.apv.wTax)
                                              .toFixed(2)
                                              .replace(
                                                /\d(?=(\d{3})+\.)/g,
                                                '$&,'
                                              )}
                                          {/* ===================================================================== */}
                                          {/* PERCENTAGE */}
                                          {/* {((data.apv.wTax / data.apv.unitPrice) * 100).toFixed(2)
                                     .replace(/\d(?=(\d{3})+\.)/g, '$&,')+ "%"} */}
                                          {/* ============================================================================ */}
                                        </h5>
                                        <h5 className='breakDownDetailValue'>
                                          <span>&#8369;</span>
                                          {' ' +
                                            (data.apv.netPricePerItem * 1)
                                              .toFixed(2)
                                              .replace(
                                                /\d(?=(\d{3})+\.)/g,
                                                '$&,'
                                              )}
                                        </h5>

                                        {/* <h5>
                                   <span>&#8369;</span>
                                   {" " + parseFloat(data.apv.vat).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                 </h5> */}
                                      </div>
                                    </div>
                                  </>
                                ) : null}

                                <div id='newBreakdown' className='newBreakdown'>
                                  <span className='newBreakDownLabel1'>
                                    Sub Total Gross Price: &#8369;{' '}
                                  </span>
                                  <span className='newBreakDown1'></span>
                                  <br />
                                  <span className='newBreakDownLabel2'>
                                    Sub Total Net Price: &#8369;{' '}
                                  </span>
                                  <span className='newBreakDown2'></span>
                                </div>
                              </div>

                              <div className='projectClassListContent3'>
                                {this.state.editCrfDetails === true &&
                                  this.state.newProjectClass.length >= 2 &&
                                  this.state.newProjectClass.length >= 1 ? (
                                  <button
                                    id={data.data}
                                    type='button'
                                    className='removeProjectClassButton'
                                    onClickCapture={
                                      this.handleRemoveProjectClass
                                    }
                                  >
                                    &times;
                                  </button>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                    {this.state.editCrfDetails ? (
                      <div className='addProjectClassForReturn'>
                        <button type='button' onClick={this.addProjectClass}>
                          + Add Project Class
                        </button>
                      </div>
                    ) : null}

                    {/* == END OF PROJECTCLASSES =============================================================================================== */}
                    <div className='finalComputationContainer'>
                      <div className='finalComputation1'>
                        <h4>Total Gross Price</h4>
                        <h4>Total Net Price</h4>
                      </div>
                      <div className='finalComputation2'>
                        <h4>
                          &#8369;
                          <span id='finalComputationTotalGrossPrice'>
                            {this.state.grandTotalGrossPrice}
                          </span>
                          {/* <span>&#8369;</span>
                       {" " + (totalGrossPrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} */}
                        </h4>
                        <h4>
                          &#8369;
                          <span id='finalComputationTotalNetPrice'>
                            {this.state.grandTotalNetPrice}
                          </span>
                          {/* <span>&#8369;</span>
                       {" " + toFixed.replace(/\d(?=(\d{3})+\.)/g, '$&,')} */}
                        </h4>
                      </div>
                    </div>

                    {context.state.userRole === 'Requestor' ? (
                      <div
                        className='errorHintResubmission'
                        id='errorHintResubmission'
                      >
                        <i class='fas fa-exclamation-triangle'></i>
                        <span>Error:</span>
                        <span id='errorHintResubmissionText'></span>
                      </div>
                    ) : null}

                    {context.state.userRole === 'Requestor' &&
                      this.state.editCrfDetails === true ? (
                      <div className='approverBtnField'>
                        <button
                          type='button'
                          onClick={this.handleCancelResubmit}
                          className='departmentHeadReturnButton'
                          id='approverBtnFieldResubmit2'
                        >
                          Cancel
                        </button>
                        <button
                          type='submit'
                          className='departmentHeadApproveButton'
                          id='approverBtnFieldResubmit'
                        >
                          Resubmit
                        </button>
                      </div>
                    ) : null}

                    {context.state.userRole === 'Department Head' &&
                      this.state.status === 'For Approval' ? (
                      <div className='approverBtnField'>
                        <button
                          type='button'
                          onClick={this.handleShowRejectModal}
                          className='departmentHeadReturnButton'
                        >
                          Rejected
                        </button>

                        <button
                          type='button'
                          onClick={this.handleShowReturnModal}
                          className='departmentHeadReturnButton'
                        >
                          Return
                        </button>
                        <button
                          type='button'
                          onClick={this.handleShowApproveModal}
                          className='departmentHeadApproveButton'
                        >
                          Approve
                        </button>
                      </div>
                    ) : null}

                    {context.state.userRole === 'Comptroller' &&
                      this.state.status === 'For Comptroller Approval' ? (
                      <div className='approverBtnField'>
                        <button
                          type='button'
                          onClick={this.handleShowRejectModal}
                          className='departmentHeadReturnButton'
                        >
                          Reject
                        </button>
                        <button
                          type='button'
                          onClick={this.handleShowCompApproveModal}
                          className='departmentHeadApproveButton'
                        >
                          Endorse to COO
                        </button>
                        <button
                          type='button'
                          onClick={this.handleShowCOOApproveModal}
                          className='departmentHeadApproveButton'
                        >
                          Approve
                        </button>
                      </div>
                    ) : null}

                    {context.state.userRole === 'COO' &&
                      this.state.status === 'For COO Approval' ? (
                      <div className='approverBtnField'>
                        <button
                          type='button'
                          onClick={this.handleShowRejectModal}
                          className='departmentHeadReturnButton'
                        >
                          Reject
                        </button>
                        <button
                          type='button'
                          onClick={this.handleShowCOOApproveModal}
                          className='departmentHeadApproveButton'
                        >
                          Approve
                        </button>
                      </div>
                    ) : null}

                    {context.state.userRole === 'Accounting Staff' &&
                      this.state.status === 'For Transmittal' ? (
                      <div className='approverBtnField'>
                        {/* <button type="button" onClick={this.handleShowReturnModal} className="departmentHeadReturnButton">
                       Return
                     </button>  */}
                        {this.state.addToQueue ? (
                          <button
                            type='button'
                            onClick={() =>
                              this.addQueue(
                                this.state.crfNo,
                                this.state.grandTotalNetPrice,
                                this.state.creationDate
                              )
                            }
                            className='inQueue'
                          >
                            Add to Queue
                          </button>
                        ) : null}

                        <button
                          type='button'
                          onClick={this.handleShowForTransmittalModal}
                          className='departmentHeadApproveButton'
                        >
                          Mark as Transmitted
                        </button>
                      </div>
                    ) : null}

                    {context.state.userRole === 'Accounting Staff' &&
                      this.state.status === 'For Review' ? (
                      <div className='approverBtnField'>
                        <button
                          type='button'
                          onClick={this.handleShowRejectModal}
                          className='departmentHeadReturnButton'
                        >
                          Reject
                        </button>
                        <button
                          type='button'
                          onClick={this.handleShowReturnModal}
                          className='departmentHeadReturnButton'
                        >
                          Return
                        </button>
                        <button
                          type='button'
                          onClick={this.handleShowReviewModal}
                          className='departmentHeadApproveButton'
                        >
                          Mark as Reviewed
                        </button>
                      </div>
                    ) : null}

                    {context.state.userRole === 'Accounting Manager' &&
                      this.state.status === 'For Endorsement' ? (
                      <div className='approverBtnField'>
                        <button
                          type='button'
                          onClick={this.handleShowOnHoldModal}
                          className='departmentHeadReturnButton'
                        >
                          On Hold
                        </button>
                        <button
                          type='button'
                          onClick={this.handleShowEndorseModal}
                          className='departmentHeadApproveButton'
                        >
                          Process
                        </button>
                      </div>
                    ) : null}

                    {context.state.userRole === 'Accounting Manager' &&
                      this.state.status === 'On Hold' ? (
                      <div className='approverBtnField'>
                        <button
                          type='button'
                          onClick={this.handleShowEndorseModal}
                          className='departmentHeadApproveButton'
                        >
                          Process
                        </button>
                      </div>
                    ) : null}

                    <div className='approverField'>
                      {/* STAMPS */}
                      {/* DEPARTMENT STAMP */}
                      {this.state.departmentApprover ? (
                        <div className='stampContainer'>
                          <img
                            className='approvedStamp'
                            src={ApprovedStamp}
                            alt=''
                          />
                          <h5>{this.state.departmentApprover}</h5>
                          <h6>
                            {this.state.requestingDepartment + '/'}Department
                            Head
                          </h6>
                          {/* <h6>{this.state.rejectionMessage.role}</h6> */}
                        </div>
                      ) : null}

                      {this.state.rejectionMessage &&
                        this.state.status === 'Returned' ? (
                        <div className='stampContainer'>
                          <img
                            className='approvedStamp'
                            src={ReturnedStamp}
                            alt=''
                          />
                          <h5>{this.state.rejectionMessage.name}</h5>
                          {this.state.rejectionMessage.role ? (
                            <h6>{this.state.rejectionMessage.role}</h6>
                          ) : null}
                        </div>
                      ) : null}

                      {this.state.rejectionMessage &&
                        this.state.status === 'Rejected' ? (
                        <div className='stampContainer'>
                          <img
                            className='approvedStamp'
                            src={RejectedStamp}
                            alt=''
                          />
                          <h5>{this.state.rejectionMessage.name}</h5>
                          {this.state.rejectionMessage.role ? (
                            <h6>
                              {this.state.requestingDepartment +
                                '/' +
                                this.state.rejectionMessage.role}
                            </h6>
                          ) : null}
                        </div>
                      ) : null}

                      {this.state.comptrollerApprover ? (
                        <div className='stampContainer'>
                          <img
                            className='approvedStamp'
                            src={ApprovedStamp}
                            alt=''
                          />
                          <h5>{this.state.comptrollerApprover}</h5>
                          <h6>Comptroller</h6>
                          {/* <h6>{this.state.rejectionMessage.role}</h6> */}
                        </div>
                      ) : null}

                      {this.state.cooApprover ? (
                        <div className='stampContainer'>
                          <img
                            className='approvedStamp'
                            src={ApprovedStamp}
                            alt=''
                          />
                          <h5>{this.state.cooApprover}</h5>
                          <h6>COO</h6>
                          {/* <h6>{this.state.rejectionMessage.role}</h6> */}
                        </div>
                      ) : null}

                      {this.state.accountingApprover ? (
                        <div className='stampContainer'>
                          <img
                            className='approvedStamp'
                            src={ReviewedStamp}
                            alt=''
                          />
                          <h5>{this.state.accountingApprover}</h5>
                          <h6>Accounting Staff</h6>
                          {/* <h6>{this.state.rejectionMessage.role}</h6> */}
                        </div>
                      ) : null}

                      {this.state.rejectionMessage &&
                        this.state.status === 'On Hold' ? (
                        <div className='stampContainer'>
                          <img
                            className='approvedStamp'
                            src={OnHoldStamp}
                            alt=''
                          />
                          <h5>{this.state.rejectionMessage.name}</h5>
                          <h6>Accounting Manager</h6>
                          {/* <h5>{this.state.rejectionMessage.name}</h5>
                         {this.state.rejectionMessage.role ?
                         <h6>{this.state.rejectionMessage.role}</h6>
                       : null} */}
                        </div>
                      ) : null}

                      {this.state.status === 'In Process' ||
                        this.state.status === 'Check Preparation' ||
                        this.state.status === 'Check Available' ||
                        this.state.status === 'Check Released' ? (
                        <div className='stampContainer'>
                          <img
                            className='approvedStamp'
                            src={ApprovedStamp}
                            alt=''
                          />
                          {/* <h5>{this.state.accountingApprover}</h5> */}
                          <h5>
                            {this.state.accountingManager.firstName +
                              ' ' +
                              this.state.accountingManager.lastName}
                          </h5>
                          <h6>Accounting Manager</h6>
                          {/* <h6>{this.state.rejectionMessage.role}</h6> */}
                        </div>
                      ) : null}
                    </div>

                    {/* END OF CRF CONTENT 2 */}
                  </div>
                </div>
              )}

              {/* END OF CONTAINER 2 */}
            </div>
          </div>
        )}
      </CrfContext.Consumer>
    )
  }
}

const errorChecker = {
  color: 'red'
}

const padding1 = {
  paddingRight: '5px'
}

const marginTop = {
  marginTop: '20px'
}

const marginBottom = {
  marginBottom: '10px'
}

const displayNone = {
  display: 'none'
}

export default CheckRequest
